export const playerData = [
  {
    image: require('../assets/player-img-1.png'),
    playerName: 'Chase Daniel (QB)',
    owner: 'Circa Trout',
    positon: 'Linebacker',
    age: '31 years',
    date: 'Sep 10, 2021',
  },
  {
    image: require('../assets/player-img-2.png'),
    playerName: 'Justin Herbert (QB)',
    owner: 'Circa Trout',
    positon: 'Linebacker',
    age: '31 years',
    date: 'Sep 10, 2021',
  },
  {
    image: require('../assets/player-img-3.png'),
    playerName: 'Najee Harris (RB)',
    owner: 'Circa Trout',
    positon: 'Linebacker',
    age: '31 years',
    date: 'Sep 10, 2021',
  },
  {
    image: require('../assets/player-img-4.png'),
    playerName: 'Rhamondre Stevenson (RB)',
    owner: 'Circa Trout',
    positon: 'Linebacker',
    age: '31 years',
    date: 'Sep 10, 2021',
  },
  {
    image: require('../assets/player-img-5.png'),
    playerName: 'Damien Harris (RB)',
    owner: 'Circa Trout',
    positon: 'Linebacker',
    age: '31 years',
    date: 'Sep 10, 2021',
  },
  {
    image: require('../assets/player-img-6.png'),
    playerName: 'Dare Ogunbowale (RB)',
    owner: 'Circa Trout',
    positon: 'Linebacker',
    age: '31 years',
    date: 'Sep 10, 2021',
  },
  {
    image: require('../assets/player-img-7.png'),
    playerName: 'Rachaad White (RB)',
    owner: 'Circa Trout',
    positon: 'Linebacker',
    age: '31 years',
    date: 'Sep 10, 2021',
  },
  {
    image: require('../assets/player-img-8.png'),
    playerName: 'Breece Hall (RB)',
    owner: 'Circa Trout',
    positon: 'Linebacker',
    age: '31 years',
    date: 'Sep 10, 2021',
  },
  {
    image: require('../assets/player-img-1.png'),
    playerName: 'Chase Daniel (QB)',
    owner: 'Circa Trout',
    positon: 'Linebacker',
    age: '31 years',
    date: 'Sep 10, 2021',
  },
  {
    image: require('../assets/player-img-2.png'),
    playerName: 'Justin Herbert (QB)',
    owner: 'Circa Trout',
    positon: 'Linebacker',
    age: '31 years',
    date: 'Sep 10, 2021',
  },
  {
    image: require('../assets/player-img-3.png'),
    playerName: 'Najee Harris (RB)',
    owner: 'Circa Trout',
    positon: 'Linebacker',
    age: '31 years',
    date: 'Sep 10, 2021',
  },
  {
    image: require('../assets/player-img-4.png'),
    playerName: 'Rhamondre Stevenson (RB)',
    owner: 'Circa Trout',
    positon: 'Linebacker',
    age: '31 years',
    date: 'Sep 10, 2021',
  },
  {
    image: require('../assets/player-img-5.png'),
    playerName: 'Damien Harris (RB)',
    owner: 'Circa Trout',
    positon: 'Linebacker',
    age: '31 years',
    date: 'Sep 10, 2021',
  },
  {
    image: require('../assets/player-img-6.png'),
    playerName: 'Dare Ogunbowale (RB)',
    owner: 'Circa Trout',
    positon: 'Linebacker',
    age: '31 years',
    date: 'Sep 10, 2021',
  },
  {
    image: require('../assets/player-img-7.png'),
    playerName: 'Rachaad White (RB)',
    owner: 'Circa Trout',
    positon: 'Linebacker',
    age: '31 years',
    date: 'Sep 10, 2021',
  },
  {
    image: require('../assets/player-img-8.png'),
    playerName: 'Breece Hall (RB)',
    owner: 'Circa Trout',
    positon: 'Linebacker',
    age: '31 years',
    date: 'Sep 10, 2021',
  },
  {
    image: require('../assets/player-img-1.png'),
    playerName: 'Chase Daniel (QB)',
    owner: 'Circa Trout',
    positon: 'Linebacker',
    age: '31 years',
    date: 'Sep 10, 2021',
  },
  {
    image: require('../assets/player-img-2.png'),
    playerName: 'Justin Herbert (QB)',
    owner: 'Circa Trout',
    positon: 'Linebacker',
    age: '31 years',
    date: 'Sep 10, 2021',
  },
  {
    image: require('../assets/player-img-3.png'),
    playerName: 'Najee Harris (RB)',
    owner: 'Circa Trout',
    positon: 'Linebacker',
    age: '31 years',
    date: 'Sep 10, 2021',
  },
  {
    image: require('../assets/player-img-4.png'),
    playerName: 'Rhamondre Stevenson (RB)',
    owner: 'Circa Trout',
    positon: 'Linebacker',
    age: '31 years',
    date: 'Sep 10, 2021',
  },
]

export const leagueScoreData = [
  {
    image: require('../assets/heat-wave-square-1.png'),
    title: 'Hear Wave Square',
    date: new Date(),
    scores: [1, 2],
  },
  {
    image: require('../assets/heat-wave-square-1.png'),
    title: 'Hear Wave Square',
    date: new Date(),
    scores: [1, 2],
  },
  {
    image: require('../assets/heat-wave-square-1.png'),
    title: 'Hear Wave Square',
    date: new Date(),
    scores: [1, 2],
  },
  {
    image: require('../assets/heat-wave-square-1.png'),
    title: 'Hear Wave Square',
    date: new Date(),
    scores: [1, 2],
  },
  {
    image: require('../assets/heat-wave-square-1.png'),
    title: 'Hear Wave Square',
    date: new Date(),
    scores: [1, 2],
  },
  {
    image: require('../assets/heat-wave-square-1.png'),
    title: 'Hear Wave Square',
    date: new Date(),
    scores: [1, 2],
  },
  {
    image: require('../assets/heat-wave-square-1.png'),
    title: 'Hear Wave Square',
    date: new Date(),
    scores: [1, 2],
  },
  {
    image: require('../assets/heat-wave-square-1.png'),
    title: 'Hear Wave Square',
    date: new Date(),
    scores: [1, 2],
  },
  {
    image: require('../assets/heat-wave-square-1.png'),
    title: 'Hear Wave Square',
    date: new Date(),
    scores: [1, 2],
  },
  {
    image: require('../assets/heat-wave-square-1.png'),
    title: 'Hear Wave Square',
    date: new Date(),
    scores: [1, 2],
  },
  {
    image: require('../assets/heat-wave-square-1.png'),
    title: 'Hear Wave Square',
    date: new Date(),
    scores: [1, 2],
  },
  {
    image: require('../assets/heat-wave-square-1.png'),
    title: 'Hear Wave Square',
    date: new Date(),
    scores: [1, 2],
  },
]

export const teamCardData = [
  {
    text: 'Madden',
    direction: 'East',
    imageUrl: require('../assets/teams/defiance.png'),
    title: 'Defiance',
    link: 'Twitter: @DeFiance_UFAFL',
  },
  {
    text: 'Madden',
    direction: 'East',
    imageUrl: require('../assets/teams/rage.png'),
    title: 'Rage',
    link: 'Alex@sevenseasblockchainsports.com',
  },
  {
    text: 'Madden',
    direction: 'East',
    imageUrl: require('../assets/teams/storm_breakers.png'),
    title: 'Storm Breakers',
    link: 'Twitter: @StormBreakersFF',
  },
  {
    text: 'Madden',
    direction: 'East',
    imageUrl: require('../assets/teams/the_beast.png'),
    title: 'The Beast',
    link: 'Twitter: @TheBeastUFAFL',
  },
  {
    text: 'Madden',
    direction: 'North',
    imageUrl: require('../assets/teams/circa_sports_trout.png'),
    title: 'Circa Sports Trout',
    link: 'Based in Las Vegas NV Twitter: @CircaTrout',
  },
  {
    text: 'Madden',
    direction: 'North',
    imageUrl: require('../assets/teams/outcasts.png'),
    title: 'Outcasts',
    link: 'Bufafloutcasts@gmail.com',
  },
  {
    text: 'Madden',
    direction: 'North',
    imageUrl: require('../assets/teams/rowdys.png'),
    title: 'Rowdys',
    link: 'Twitter: @rowdysfootball',
  },
  {
    text: 'Madden',
    direction: 'North',
    imageUrl: require('../assets/teams/the_flying_foxes.png'),
    title: 'The Flying Foxes',
    link: '',
  },
  {
    text: 'Madden',
    direction: 'East',
    imageUrl: require('../assets/teams/canwest_gladiators.png'),
    title: 'CanWest Gladiators',
    link: 'chad@canwestfantasysports.comTwitter: @GladiatorsUFAFL',
  },
  {
    text: 'Madden',
    direction: 'East',
    imageUrl: require('../assets/teams/kingsmen.png'),
    title: 'Kingsmen',
    link: '',
  },
  {
    text: 'Madden',
    direction: 'East',
    imageUrl: require('../assets/teams/legion.png'),
    title: 'Legion',
    link: 'legion.ufafl@gmail.comTwitter: @LEGIONUFAFL',
  },
  {
    text: 'Madden',
    direction: 'East',
    imageUrl: require('../assets/teams/the_resistance.png'),
    title: 'The Resistance',
    link: 'TheResistanceGM@yahoo.com',
  },
  {
    text: 'Madden',
    direction: 'East',
    imageUrl: require('../assets/teams/empire.png'),
    title: 'Empire',
    link: 'Twitter: @THEEMPIREFANTA1',
  },
  {
    text: 'Madden',
    direction: 'East',
    imageUrl: require('../assets/teams/kraken.png'),
    title: 'Kraken',
    link: 'Twitter: @KrakenUFAFL',
  },
  {
    text: 'Madden',
    direction: 'East',
    imageUrl: require('../assets/teams/seven_angles.png'),
    title: 'Seven7 Angels',
    link: 'djones@hedgeye.COM',
  },
  {
    text: 'Madden',
    direction: 'East',
    imageUrl: require('../assets/teams/silverbacks.png'),
    title: 'Silverbacks',
    link: 'silverbacks.ufafl@gmail.com',
  },
  {
    text: 'Madden',
    direction: 'East',
    imageUrl: require('../assets/teams/doom.png'),
    title: 'Doom',
    link: 'Twitter: @DoomUFAFL',
  },
  {
    text: 'Madden',
    direction: 'East',
    imageUrl: require('../assets/teams/gridiron_seals.png'),
    title: 'Gridiron Seals',
    link: 'Based in Regina, SK, CanadaTwitter: @GridIronSeals',
  },
  {
    text: 'Madden',
    direction: 'East',
    imageUrl: require('../assets/teams/tiger_sharks.png'),
    title: 'Tiger Sharks',
    link: '',
  },
  {
    text: 'Madden',
    direction: 'East',
    imageUrl: require('../assets/teams/monsters.png'),
    title: 'Monsters',
    link: 'Twitter: @turfmonsters21',
  },
]

export const playerStatsData = [
  {
    name: 'Mahomes, Patrick KCC QB',
    pts: 650.3,
    avg: 38.2529,
    status: 'Paradise Block Hawks',
    bye: 8,
    salary: 35793382,
    data: [
      {
        1: 54.95,
        2: 28.75,
        3: 26.3,
        4: 38.55,
        5: 47.8,
        6: 32.6,
        7: 42.15,
        8: 8,
        9: 50.1,
        10: 49.45,
        11: 41.35,
        12: 29.6,
        13: 27.55,
        14: 35.35,
        15: 48.05,
        16: 33.5,
        17: 41.2,
        18: 23.05,
      },
    ],
  },
  {
    name: 'Allen, Josh BUF QB',
    pts: 607.75,
    avg: 37.9844,
    status: 'TDU',
    bye: 7,
    salary: 16372282,
    data: [
      {
        1: 54.95,
        2: 28.75,
        3: 26.3,
        4: 38.55,
        5: 47.8,
        6: 32.6,
        7: 42.15,
        8: 8,
        9: 50.1,
        10: 49.45,
        11: 41.35,
        12: 29.6,
        13: 27.55,
        14: 35.35,
        15: 48.05,
        16: 33.5,
        17: 41.2,
        18: 23.05,
      },
    ],
  },
  {
    name: 'Allen, Josh BUF QB',
    pts: 607.75,
    avg: 37.9844,
    status: 'TDU',
    bye: 7,
    salary: 16372282,
    data: [
      {
        1: 54.95,
        2: 28.75,
        3: 26.3,
        4: 38.55,
        5: 47.8,
        6: 32.6,
        7: 42.15,
        8: 8,
        9: 50.1,
        10: 49.45,
        11: 41.35,
        12: 29.6,
        13: 27.55,
        14: 35.35,
        15: 48.05,
        16: 33.5,
        17: 41.2,
        18: 23.05,
      },
    ],
  },
  {
    name: 'Allen, Josh BUF QB',
    pts: 607.75,
    avg: 37.9844,
    status: 'TDU',
    bye: 7,
    salary: 16372282,
    data: [
      {
        1: 54.95,
        2: 28.75,
        3: 26.3,
        4: 38.55,
        5: 47.8,
        6: 32.6,
        7: 42.15,
        8: 8,
        9: 50.1,
        10: 49.45,
        11: 41.35,
        12: 29.6,
        13: 27.55,
        14: 35.35,
        15: 48.05,
        16: 33.5,
        17: 41.2,
        18: 23.05,
      },
    ],
  },
  {
    name: 'Allen, Josh BUF QB',
    pts: 607.75,
    avg: 37.9844,
    status: 'TDU',
    bye: 7,
    salary: 16372282,
    data: [
      {
        1: 54.95,
        2: 28.75,
        3: 26.3,
        4: 38.55,
        5: 47.8,
        6: 32.6,
        7: 42.15,
        8: 8,
        9: 50.1,
        10: 49.45,
        11: 41.35,
        12: 29.6,
        13: 27.55,
        14: 35.35,
        15: 48.05,
        16: 33.5,
        17: 41.2,
        18: 23.05,
      },
    ],
  },
  {
    name: 'Allen, Josh BUF QB',
    pts: 607.75,
    avg: 37.9844,
    status: 'TDU',
    bye: 7,
    salary: 16372282,
    data: [
      {
        1: 54.95,
        2: 28.75,
        3: 26.3,
        4: 38.55,
        5: 47.8,
        6: 32.6,
        7: 42.15,
        8: 8,
        9: 50.1,
        10: 49.45,
        11: 41.35,
        12: 29.6,
        13: 27.55,
        14: 35.35,
        15: 48.05,
        16: 33.5,
        17: 41.2,
        18: 23.05,
      },
    ],
  },
  {
    name: 'Allen, Josh BUF QB',
    pts: 607.75,
    avg: 37.9844,
    status: 'TDU',
    bye: 7,
    salary: 16372282,
    data: [
      {
        1: 54.95,
        2: 28.75,
        3: 26.3,
        4: 38.55,
        5: 47.8,
        6: 32.6,
        7: 42.15,
        8: 8,
        9: 50.1,
        10: 49.45,
        11: 41.35,
        12: 29.6,
        13: 27.55,
        14: 35.35,
        15: 48.05,
        16: 33.5,
        17: 41.2,
        18: 23.05,
      },
    ],
  },
  {
    name: 'Allen, Josh BUF QB',
    pts: 607.75,
    avg: 37.9844,
    status: 'TDU',
    bye: 7,
    salary: 16372282,
    data: [
      {
        1: 54.95,
        2: 28.75,
        3: 26.3,
        4: 38.55,
        5: 47.8,
        6: 32.6,
        7: 42.15,
        8: 8,
        9: 50.1,
        10: 49.45,
        11: 41.35,
        12: 29.6,
        13: 27.55,
        14: 35.35,
        15: 48.05,
        16: 33.5,
        17: 41.2,
        18: 23.05,
      },
    ],
  },
  {
    name: 'Allen, Josh BUF QB',
    pts: 607.75,
    avg: 37.9844,
    status: 'TDU',
    bye: 7,
    salary: 16372282,
    data: [
      {
        1: 54.95,
        2: 28.75,
        3: 26.3,
        4: 38.55,
        5: 47.8,
        6: 32.6,
        7: 42.15,
        8: 8,
        9: 50.1,
        10: 49.45,
        11: 41.35,
        12: 29.6,
        13: 27.55,
        14: 35.35,
        15: 48.05,
        16: 33.5,
        17: 41.2,
        18: 23.05,
      },
    ],
  },
  {
    name: 'Allen, Josh BUF QB',
    pts: 607.75,
    avg: 37.9844,
    status: 'TDU',
    bye: 7,
    salary: 16372282,
    data: [
      {
        1: 54.95,
        2: 28.75,
        3: 26.3,
        4: 38.55,
        5: 47.8,
        6: 32.6,
        7: 42.15,
        8: 8,
        9: 50.1,
        10: 49.45,
        11: 41.35,
        12: 29.6,
        13: 27.55,
        14: 35.35,
        15: 48.05,
        16: 33.5,
        17: 41.2,
        18: 23.05,
      },
    ],
  },
  {
    name: 'Allen, Josh BUF QB',
    pts: 607.75,
    avg: 37.9844,
    status: 'TDU',
    bye: 7,
    salary: 16372282,
    data: [
      {
        1: 54.95,
        2: 28.75,
        3: 26.3,
        4: 38.55,
        5: 47.8,
        6: 32.6,
        7: 42.15,
        8: 8,
        9: 50.1,
        10: 49.45,
        11: 41.35,
        12: 29.6,
        13: 27.55,
        14: 35.35,
        15: 48.05,
        16: 33.5,
        17: 41.2,
        18: 23.05,
      },
    ],
  },
  {
    name: 'Allen, Josh BUF QB',
    pts: 607.75,
    avg: 37.9844,
    status: 'TDU',
    bye: 7,
    salary: 16372282,
    data: [
      {
        1: 54.95,
        2: 28.75,
        3: 26.3,
        4: 38.55,
        5: 47.8,
        6: 32.6,
        7: 42.15,
        8: 8,
        9: 50.1,
        10: 49.45,
        11: 41.35,
        12: 29.6,
        13: 27.55,
        14: 35.35,
        15: 48.05,
        16: 33.5,
        17: 41.2,
        18: 23.05,
      },
    ],
  },
  {
    name: 'Allen, Josh BUF QB',
    pts: 607.75,
    avg: 37.9844,
    status: 'TDU',
    bye: 7,
    salary: 16372282,
    data: [
      {
        1: 54.95,
        2: 28.75,
        3: 26.3,
        4: 38.55,
        5: 47.8,
        6: 32.6,
        7: 42.15,
        8: 8,
        9: 50.1,
        10: 49.45,
        11: 41.35,
        12: 29.6,
        13: 27.55,
        14: 35.35,
        15: 48.05,
        16: 33.5,
        17: 41.2,
        18: 23.05,
      },
    ],
  },
  {
    name: 'Allen, Josh BUF QB',
    pts: 607.75,
    avg: 37.9844,
    status: 'TDU',
    bye: 7,
    salary: 16372282,
    data: [
      {
        1: 54.95,
        2: 28.75,
        3: 26.3,
        4: 38.55,
        5: 47.8,
        6: 32.6,
        7: 42.15,
        8: 8,
        9: 50.1,
        10: 49.45,
        11: 41.35,
        12: 29.6,
        13: 27.55,
        14: 35.35,
        15: 48.05,
        16: 33.5,
        17: 41.2,
        18: 23.05,
      },
    ],
  },
  {
    name: 'Allen, Josh BUF QB',
    pts: 607.75,
    avg: 37.9844,
    status: 'TDU',
    bye: 7,
    salary: 16372282,
    data: [
      {
        1: 54.95,
        2: 28.75,
        3: 26.3,
        4: 38.55,
        5: 47.8,
        6: 32.6,
        7: 42.15,
        8: 8,
        9: 50.1,
        10: 49.45,
        11: 41.35,
        12: 29.6,
        13: 27.55,
        14: 35.35,
        15: 48.05,
        16: 33.5,
        17: 41.2,
        18: 23.05,
      },
    ],
  },
  {
    name: 'Allen, Josh BUF QB',
    pts: 607.75,
    avg: 37.9844,
    status: 'TDU',
    bye: 7,
    salary: 16372282,
    data: [
      {
        1: 54.95,
        2: 28.75,
        3: 26.3,
        4: 38.55,
        5: 47.8,
        6: 32.6,
        7: 42.15,
        8: 8,
        9: 50.1,
        10: 49.45,
        11: 41.35,
        12: 29.6,
        13: 27.55,
        14: 35.35,
        15: 48.05,
        16: 33.5,
        17: 41.2,
        18: 23.05,
      },
    ],
  },
  {
    name: 'Allen, Josh BUF QB',
    pts: 607.75,
    avg: 37.9844,
    status: 'TDU',
    bye: 7,
    salary: 16372282,
    data: [
      {
        1: 54.95,
        2: 28.75,
        3: 26.3,
        4: 38.55,
        5: 47.8,
        6: 32.6,
        7: 42.15,
        8: 8,
        9: 50.1,
        10: 49.45,
        11: 41.35,
        12: 29.6,
        13: 27.55,
        14: 35.35,
        15: 48.05,
        16: 33.5,
        17: 41.2,
        18: 23.05,
      },
    ],
  },
  {
    name: 'Allen, Josh BUF QB',
    pts: 607.75,
    avg: 37.9844,
    status: 'TDU',
    bye: 7,
    salary: 16372282,
    data: [
      {
        1: 54.95,
        2: 28.75,
        3: 26.3,
        4: 38.55,
        5: 47.8,
        6: 32.6,
        7: 42.15,
        8: 8,
        9: 50.1,
        10: 49.45,
        11: 41.35,
        12: 29.6,
        13: 27.55,
        14: 35.35,
        15: 48.05,
        16: 33.5,
        17: 41.2,
        18: 23.05,
      },
    ],
  },
  {
    name: 'Allen, Josh BUF QB',
    pts: 607.75,
    avg: 37.9844,
    status: 'TDU',
    bye: 7,
    salary: 16372282,
    data: [
      {
        1: 54.95,
        2: 28.75,
        3: 26.3,
        4: 38.55,
        5: 47.8,
        6: 32.6,
        7: 42.15,
        8: 8,
        9: 50.1,
        10: 49.45,
        11: 41.35,
        12: 29.6,
        13: 27.55,
        14: 35.35,
        15: 48.05,
        16: 33.5,
        17: 41.2,
        18: 23.05,
      },
    ],
  },
  {
    name: 'Allen, Josh BUF QB',
    pts: 607.75,
    avg: 37.9844,
    status: 'TDU',
    bye: 7,
    salary: 16372282,
    data: [
      {
        1: 54.95,
        2: 28.75,
        3: 26.3,
        4: 38.55,
        5: 47.8,
        6: 32.6,
        7: 42.15,
        8: 8,
        9: 50.1,
        10: 49.45,
        11: 41.35,
        12: 29.6,
        13: 27.55,
        14: 35.35,
        15: 48.05,
        16: 33.5,
        17: 41.2,
        18: 23.05,
      },
    ],
  },
  {
    name: 'Allen, Josh BUF QB',
    pts: 607.75,
    avg: 37.9844,
    status: 'TDU',
    bye: 7,
    salary: 16372282,
    data: [
      {
        1: 54.95,
        2: 28.75,
        3: 26.3,
        4: 38.55,
        5: 47.8,
        6: 32.6,
        7: 42.15,
        8: 8,
        9: 50.1,
        10: 49.45,
        11: 41.35,
        12: 29.6,
        13: 27.55,
        14: 35.35,
        15: 48.05,
        16: 33.5,
        17: 41.2,
        18: 23.05,
      },
    ],
  },
  {
    name: 'Allen, Josh BUF QB',
    pts: 607.75,
    avg: 37.9844,
    status: 'TDU',
    bye: 7,
    salary: 16372282,
    data: [
      {
        1: 54.95,
        2: 28.75,
        3: 26.3,
        4: 38.55,
        5: 47.8,
        6: 32.6,
        7: 42.15,
        8: 8,
        9: 50.1,
        10: 49.45,
        11: 41.35,
        12: 29.6,
        13: 27.55,
        14: 35.35,
        15: 48.05,
        16: 33.5,
        17: 41.2,
        18: 23.05,
      },
    ],
  },
  {
    name: 'Allen, Josh BUF QB',
    pts: 607.75,
    avg: 37.9844,
    status: 'TDU',
    bye: 7,
    salary: 16372282,
    data: [
      {
        1: 54.95,
        2: 28.75,
        3: 26.3,
        4: 38.55,
        5: 47.8,
        6: 32.6,
        7: 42.15,
        8: 8,
        9: 50.1,
        10: 49.45,
        11: 41.35,
        12: 29.6,
        13: 27.55,
        14: 35.35,
        15: 48.05,
        16: 33.5,
        17: 41.2,
        18: 23.05,
      },
    ],
  },
  {
    name: 'Allen, Josh BUF QB',
    pts: 607.75,
    avg: 37.9844,
    status: 'TDU',
    bye: 7,
    salary: 16372282,
    data: [
      {
        1: 54.95,
        2: 28.75,
        3: 26.3,
        4: 38.55,
        5: 47.8,
        6: 32.6,
        7: 42.15,
        8: 8,
        9: 50.1,
        10: 49.45,
        11: 41.35,
        12: 29.6,
        13: 27.55,
        14: 35.35,
        15: 48.05,
        16: 33.5,
        17: 41.2,
        18: 23.05,
      },
    ],
  },
  {
    name: 'Allen, Josh BUF QB',
    pts: 607.75,
    avg: 37.9844,
    status: 'TDU',
    bye: 7,
    salary: 16372282,
    data: [
      {
        1: 54.95,
        2: 28.75,
        3: 26.3,
        4: 38.55,
        5: 47.8,
        6: 32.6,
        7: 42.15,
        8: 8,
        9: 50.1,
        10: 49.45,
        11: 41.35,
        12: 29.6,
        13: 27.55,
        14: 35.35,
        15: 48.05,
        16: 33.5,
        17: 41.2,
        18: 23.05,
      },
    ],
  },
  {
    name: 'Allen, Josh BUF QB',
    pts: 607.75,
    avg: 37.9844,
    status: 'TDU',
    bye: 7,
    salary: 16372282,
    data: [
      {
        1: 54.95,
        2: 28.75,
        3: 26.3,
        4: 38.55,
        5: 47.8,
        6: 32.6,
        7: 42.15,
        8: 8,
        9: 50.1,
        10: 49.45,
        11: 41.35,
        12: 29.6,
        13: 27.55,
        14: 35.35,
        15: 48.05,
        16: 33.5,
        17: 41.2,
        18: 23.05,
      },
    ],
  },
  {
    name: 'Allen, Josh BUF QB',
    pts: 607.75,
    avg: 37.9844,
    status: 'TDU',
    bye: 7,
    salary: 16372282,
    data: [
      {
        1: 54.95,
        2: 28.75,
        3: 26.3,
        4: 38.55,
        5: 47.8,
        6: 32.6,
        7: 42.15,
        8: 8,
        9: 50.1,
        10: 49.45,
        11: 41.35,
        12: 29.6,
        13: 27.55,
        14: 35.35,
        15: 48.05,
        16: 33.5,
        17: 41.2,
        18: 23.05,
      },
    ],
  },
  {
    name: 'Allen, Josh BUF QB',
    pts: 607.75,
    avg: 37.9844,
    status: 'TDU',
    bye: 7,
    salary: 16372282,
    data: [
      {
        1: 54.95,
        2: 28.75,
        3: 26.3,
        4: 38.55,
        5: 47.8,
        6: 32.6,
        7: 42.15,
        8: 8,
        9: 50.1,
        10: 49.45,
        11: 41.35,
        12: 29.6,
        13: 27.55,
        14: 35.35,
        15: 48.05,
        16: 33.5,
        17: 41.2,
        18: 23.05,
      },
    ],
  },
  {
    name: 'Allen, Josh BUF QB',
    pts: 607.75,
    avg: 37.9844,
    status: 'TDU',
    bye: 7,
    salary: 16372282,
    data: [
      {
        1: 54.95,
        2: 28.75,
        3: 26.3,
        4: 38.55,
        5: 47.8,
        6: 32.6,
        7: 42.15,
        8: 8,
        9: 50.1,
        10: 49.45,
        11: 41.35,
        12: 29.6,
        13: 27.55,
        14: 35.35,
        15: 48.05,
        16: 33.5,
        17: 41.2,
        18: 23.05,
      },
    ],
  },
  {
    name: 'Allen, Josh BUF QB',
    pts: 607.75,
    avg: 37.9844,
    status: 'TDU',
    bye: 7,
    salary: 16372282,
    data: [
      {
        1: 54.95,
        2: 28.75,
        3: 26.3,
        4: 38.55,
        5: 47.8,
        6: 32.6,
        7: 42.15,
        8: 8,
        9: 50.1,
        10: 49.45,
        11: 41.35,
        12: 29.6,
        13: 27.55,
        14: 35.35,
        15: 48.05,
        16: 33.5,
        17: 41.2,
        18: 23.05,
      },
    ],
  },
  {
    name: 'Allen, Josh BUF QB',
    pts: 607.75,
    avg: 37.9844,
    status: 'TDU',
    bye: 7,
    salary: 16372282,
    data: [
      {
        1: 54.95,
        2: 28.75,
        3: 26.3,
        4: 38.55,
        5: 47.8,
        6: 32.6,
        7: 42.15,
        8: 8,
        9: 50.1,
        10: 49.45,
        11: 41.35,
        12: 29.6,
        13: 27.55,
        14: 35.35,
        15: 48.05,
        16: 33.5,
        17: 41.2,
        18: 23.05,
      },
    ],
  },
  {
    name: 'Allen, Josh BUF QB',
    pts: 607.75,
    avg: 37.9844,
    status: 'TDU',
    bye: 7,
    salary: 16372282,
    data: [
      {
        1: 54.95,
        2: 28.75,
        3: 26.3,
        4: 38.55,
        5: 47.8,
        6: 32.6,
        7: 42.15,
        8: 8,
        9: 50.1,
        10: 49.45,
        11: 41.35,
        12: 29.6,
        13: 27.55,
        14: 35.35,
        15: 48.05,
        16: 33.5,
        17: 41.2,
        18: 23.05,
      },
    ],
  },
  {
    name: 'Allen, Josh BUF QB',
    pts: 607.75,
    avg: 37.9844,
    status: 'TDU',
    bye: 7,
    salary: 16372282,
    data: [
      {
        1: 54.95,
        2: 28.75,
        3: 26.3,
        4: 38.55,
        5: 47.8,
        6: 32.6,
        7: 42.15,
        8: 8,
        9: 50.1,
        10: 49.45,
        11: 41.35,
        12: 29.6,
        13: 27.55,
        14: 35.35,
        15: 48.05,
        16: 33.5,
        17: 41.2,
        18: 23.05,
      },
    ],
  },
  {
    name: 'Allen, Josh BUF QB',
    pts: 607.75,
    avg: 37.9844,
    status: 'TDU',
    bye: 7,
    salary: 16372282,
    data: [
      {
        1: 54.95,
        2: 28.75,
        3: 26.3,
        4: 38.55,
        5: 47.8,
        6: 32.6,
        7: 42.15,
        8: 8,
        9: 50.1,
        10: 49.45,
        11: 41.35,
        12: 29.6,
        13: 27.55,
        14: 35.35,
        15: 48.05,
        16: 33.5,
        17: 41.2,
        18: 23.05,
      },
    ],
  },
  {
    name: 'Allen, Josh BUF QB',
    pts: 607.75,
    avg: 37.9844,
    status: 'TDU',
    bye: 7,
    salary: 16372282,
    data: [
      {
        1: 54.95,
        2: 28.75,
        3: 26.3,
        4: 38.55,
        5: 47.8,
        6: 32.6,
        7: 42.15,
        8: 8,
        9: 50.1,
        10: 49.45,
        11: 41.35,
        12: 29.6,
        13: 27.55,
        14: 35.35,
        15: 48.05,
        16: 33.5,
        17: 41.2,
        18: 23.05,
      },
    ],
  },
  {
    name: 'Allen, Josh BUF QB',
    pts: 607.75,
    avg: 37.9844,
    status: 'TDU',
    bye: 7,
    salary: 16372282,
    data: [
      {
        1: 54.95,
        2: 28.75,
        3: 26.3,
        4: 38.55,
        5: 47.8,
        6: 32.6,
        7: 42.15,
        8: 8,
        9: 50.1,
        10: 49.45,
        11: 41.35,
        12: 29.6,
        13: 27.55,
        14: 35.35,
        15: 48.05,
        16: 33.5,
        17: 41.2,
        18: 23.05,
      },
    ],
  },
  {
    name: 'Allen, Josh BUF QB',
    pts: 607.75,
    avg: 37.9844,
    status: 'TDU',
    bye: 7,
    salary: 16372282,
    data: [
      {
        1: 54.95,
        2: 28.75,
        3: 26.3,
        4: 38.55,
        5: 47.8,
        6: 32.6,
        7: 42.15,
        8: 8,
        9: 50.1,
        10: 49.45,
        11: 41.35,
        12: 29.6,
        13: 27.55,
        14: 35.35,
        15: 48.05,
        16: 33.5,
        17: 41.2,
        18: 23.05,
      },
    ],
  },
]
export const playerRosterData = [
  {
    _id: '123456781',
    name: 'Mahomes, Patrick KCC QB',
    pts: 650.3,
    age: 26,
    team: 'Paradise Block Hawks',
    bye: 8,
    playerCap: 35793382,
    playerRank: '04',
    data: [
      {
        1: 54.95,
        2: 28.75,
        3: 26.3,
        4: 38.55,
        5: 47.8,
        6: 32.6,
        7: 42.15,
        8: 8,
        9: 50.1,
        10: 49.45,
        11: 41.35,
        12: 29.6,
        13: 27.55,
        14: 35.35,
        15: 48.05,
        16: 33.5,
        17: 41.2,
        18: 23.05,
      },
    ],
  },
  {
    _id: '123456782',
    name: 'Mahomes, Patrick KCC QB',
    pts: 650.3,
    age: 26,
    team: 'Paradise Block Hawks',
    bye: 8,
    playerCap: 35793382,
    playerRank: '04',
    data: [
      {
        1: 54.95,
        2: 28.75,
        3: 26.3,
        4: 38.55,
        5: 47.8,
        6: 32.6,
        7: 42.15,
        8: 8,
        9: 50.1,
        10: 49.45,
        11: 41.35,
        12: 29.6,
        13: 27.55,
        14: 35.35,
        15: 48.05,
        16: 33.5,
        17: 41.2,
        18: 23.05,
      },
    ],
  },
  {
    _id: '123456783',
    name: 'Mahomes, Patrick KCC QB',
    pts: 650.3,
    age: 26,
    team: 'Paradise Block Hawks',
    bye: 8,
    playerCap: 35793382,
    playerRank: '04',
    data: [
      {
        1: 54.95,
        2: 28.75,
        3: 26.3,
        4: 38.55,
        5: 47.8,
        6: 32.6,
        7: 42.15,
        8: 8,
        9: 50.1,
        10: 49.45,
        11: 41.35,
        12: 29.6,
        13: 27.55,
        14: 35.35,
        15: 48.05,
        16: 33.5,
        17: 41.2,
        18: 23.05,
      },
    ],
  },
  {
    _id: '123456784',
    name: 'Mahomes, Patrick KCC QB',
    pts: 650.3,
    age: 26,
    team: 'Paradise Block Hawks',
    bye: 8,
    playerCap: 35793382,
    playerRank: '04',
    data: [
      {
        1: 54.95,
        2: 28.75,
        3: 26.3,
        4: 38.55,
        5: 47.8,
        6: 32.6,
        7: 42.15,
        8: 8,
        9: 50.1,
        10: 49.45,
        11: 41.35,
        12: 29.6,
        13: 27.55,
        14: 35.35,
        15: 48.05,
        16: 33.5,
        17: 41.2,
        18: 23.05,
      },
    ],
  },
  {
    _id: '123456785',
    name: 'Mahomes, Patrick KCC QB',
    pts: 650.3,
    age: 26,
    team: 'Paradise Block Hawks',
    bye: 8,
    playerCap: 35793382,
    playerRank: '04',
    data: [
      {
        1: 54.95,
        2: 28.75,
        3: 26.3,
        4: 38.55,
        5: 47.8,
        6: 32.6,
        7: 42.15,
        8: 8,
        9: 50.1,
        10: 49.45,
        11: 41.35,
        12: 29.6,
        13: 27.55,
        14: 35.35,
        15: 48.05,
        16: 33.5,
        17: 41.2,
        18: 23.05,
      },
    ],
  },
  {
    _id: '123456786',
    name: 'Mahomes, Patrick KCC QB',
    pts: 650.3,
    age: 26,
    team: 'Paradise Block Hawks',
    bye: 8,
    playerCap: 35793382,
    playerRank: '04',
    data: [
      {
        1: 54.95,
        2: 28.75,
        3: 26.3,
        4: 38.55,
        5: 47.8,
        6: 32.6,
        7: 42.15,
        8: 8,
        9: 50.1,
        10: 49.45,
        11: 41.35,
        12: 29.6,
        13: 27.55,
        14: 35.35,
        15: 48.05,
        16: 33.5,
        17: 41.2,
        18: 23.05,
      },
    ],
  },
  {
    _id: '123456787',
    name: 'Mahomes, Patrick KCC QB',
    pts: 650.3,
    age: 26,
    team: 'Paradise Block Hawks',
    bye: 8,
    playerCap: 35793382,
    playerRank: '04',
    data: [
      {
        1: 54.95,
        2: 28.75,
        3: 26.3,
        4: 38.55,
        5: 47.8,
        6: 32.6,
        7: 42.15,
        8: 8,
        9: 50.1,
        10: 49.45,
        11: 41.35,
        12: 29.6,
        13: 27.55,
        14: 35.35,
        15: 48.05,
        16: 33.5,
        17: 41.2,
        18: 23.05,
      },
    ],
  },
  {
    _id: '123456788',
    name: 'Mahomes, Patrick KCC QB',
    pts: 650.3,
    age: 26,
    team: 'Paradise Block Hawks',
    bye: 8,
    playerCap: 35793382,
    playerRank: '04',
    data: [
      {
        1: 54.95,
        2: 28.75,
        3: 26.3,
        4: 38.55,
        5: 47.8,
        6: 32.6,
        7: 42.15,
        8: 8,
        9: 50.1,
        10: 49.45,
        11: 41.35,
        12: 29.6,
        13: 27.55,
        14: 35.35,
        15: 48.05,
        16: 33.5,
        17: 41.2,
        18: 23.05,
      },
    ],
  },
  {
    _id: '123456789',
    name: 'Mahomes, Patrick KCC QB',
    pts: 650.3,
    age: 26,
    team: 'Paradise Block Hawks',
    bye: 8,
    playerCap: 35793382,
    playerRank: '04',
    data: [
      {
        1: 54.95,
        2: 28.75,
        3: 26.3,
        4: 38.55,
        5: 47.8,
        6: 32.6,
        7: 42.15,
        8: 8,
        9: 50.1,
        10: 49.45,
        11: 41.35,
        12: 29.6,
        13: 27.55,
        14: 35.35,
        15: 48.05,
        16: 33.5,
        17: 41.2,
        18: 23.05,
      },
    ],
  },
  {
    _id: '123456790',
    name: 'Mahomes, Patrick KCC QB',
    pts: 650.3,
    age: 26,
    team: 'Paradise Block Hawks',
    bye: 8,
    playerCap: 35793382,
    playerRank: '04',
    data: [
      {
        1: 54.95,
        2: 28.75,
        3: 26.3,
        4: 38.55,
        5: 47.8,
        6: 32.6,
        7: 42.15,
        8: 8,
        9: 50.1,
        10: 49.45,
        11: 41.35,
        12: 29.6,
        13: 27.55,
        14: 35.35,
        15: 48.05,
        16: 33.5,
        17: 41.2,
        18: 23.05,
      },
    ],
  },
  {
    _id: '123456791',
    name: 'Mahomes, Patrick KCC QB',
    pts: 650.3,
    age: 26,
    team: 'Paradise Block Hawks',
    bye: 8,
    playerCap: 35793382,
    playerRank: '04',
    data: [
      {
        1: 54.95,
        2: 28.75,
        3: 26.3,
        4: 38.55,
        5: 47.8,
        6: 32.6,
        7: 42.15,
        8: 8,
        9: 50.1,
        10: 49.45,
        11: 41.35,
        12: 29.6,
        13: 27.55,
        14: 35.35,
        15: 48.05,
        16: 33.5,
        17: 41.2,
        18: 23.05,
      },
    ],
  },
  {
    _id: '123456792',
    name: 'Mahomes, Patrick KCC QB',
    pts: 650.3,
    age: 26,
    team: 'Paradise Block Hawks',
    bye: 8,
    playerCap: 35793382,
    playerRank: '04',
    data: [
      {
        1: 54.95,
        2: 28.75,
        3: 26.3,
        4: 38.55,
        5: 47.8,
        6: 32.6,
        7: 42.15,
        8: 8,
        9: 50.1,
        10: 49.45,
        11: 41.35,
        12: 29.6,
        13: 27.55,
        14: 35.35,
        15: 48.05,
        16: 33.5,
        17: 41.2,
        18: 23.05,
      },
    ],
  },
  {
    _id: '123456793',
    name: 'Mahomes, Patrick KCC QB',
    pts: 650.3,
    age: 26,
    team: 'Paradise Block Hawks',
    bye: 8,
    playerCap: 35793382,
    playerRank: '04',
    data: [
      {
        1: 54.95,
        2: 28.75,
        3: 26.3,
        4: 38.55,
        5: 47.8,
        6: 32.6,
        7: 42.15,
        8: 8,
        9: 50.1,
        10: 49.45,
        11: 41.35,
        12: 29.6,
        13: 27.55,
        14: 35.35,
        15: 48.05,
        16: 33.5,
        17: 41.2,
        18: 23.05,
      },
    ],
  },
  {
    _id: '123456794',
    name: 'Mahomes, Patrick KCC QB',
    pts: 650.3,
    age: 26,
    team: 'Paradise Block Hawks',
    bye: 8,
    playerCap: 35793382,
    playerRank: '04',
    data: [
      {
        1: 54.95,
        2: 28.75,
        3: 26.3,
        4: 38.55,
        5: 47.8,
        6: 32.6,
        7: 42.15,
        8: 8,
        9: 50.1,
        10: 49.45,
        11: 41.35,
        12: 29.6,
        13: 27.55,
        14: 35.35,
        15: 48.05,
        16: 33.5,
        17: 41.2,
        18: 23.05,
      },
    ],
  },
  {
    _id: '123456795',
    name: 'Mahomes, Patrick KCC QB',
    pts: 650.3,
    age: 26,
    team: 'Paradise Block Hawks',
    bye: 8,
    playerCap: 35793382,
    playerRank: '04',
    data: [
      {
        1: 54.95,
        2: 28.75,
        3: 26.3,
        4: 38.55,
        5: 47.8,
        6: 32.6,
        7: 42.15,
        8: 8,
        9: 50.1,
        10: 49.45,
        11: 41.35,
        12: 29.6,
        13: 27.55,
        14: 35.35,
        15: 48.05,
        16: 33.5,
        17: 41.2,
        18: 23.05,
      },
    ],
  },
  {
    _id: '123456796',
    name: 'Mahomes, Patrick KCC QB',
    pts: 650.3,
    age: 26,
    team: 'Paradise Block Hawks',
    bye: 8,
    playerCap: 35793382,
    playerRank: '04',
    data: [
      {
        1: 54.95,
        2: 28.75,
        3: 26.3,
        4: 38.55,
        5: 47.8,
        6: 32.6,
        7: 42.15,
        8: 8,
        9: 50.1,
        10: 49.45,
        11: 41.35,
        12: 29.6,
        13: 27.55,
        14: 35.35,
        15: 48.05,
        16: 33.5,
        17: 41.2,
        18: 23.05,
      },
    ],
  },
  {
    _id: '123456797',
    name: 'Mahomes, Patrick KCC QB',
    pts: 650.3,
    age: 26,
    team: 'Paradise Block Hawks',
    bye: 8,
    playerCap: 35793382,
    playerRank: '04',
    data: [
      {
        1: 54.95,
        2: 28.75,
        3: 26.3,
        4: 38.55,
        5: 47.8,
        6: 32.6,
        7: 42.15,
        8: 8,
        9: 50.1,
        10: 49.45,
        11: 41.35,
        12: 29.6,
        13: 27.55,
        14: 35.35,
        15: 48.05,
        16: 33.5,
        17: 41.2,
        18: 23.05,
      },
    ],
  },
  {
    _id: '123456798',
    name: 'Mahomes, Patrick KCC QB',
    pts: 650.3,
    age: 26,
    team: 'Paradise Block Hawks',
    bye: 8,
    playerCap: 35793382,
    playerRank: '04',
    data: [
      {
        1: 54.95,
        2: 28.75,
        3: 26.3,
        4: 38.55,
        5: 47.8,
        6: 32.6,
        7: 42.15,
        8: 8,
        9: 50.1,
        10: 49.45,
        11: 41.35,
        12: 29.6,
        13: 27.55,
        14: 35.35,
        15: 48.05,
        16: 33.5,
        17: 41.2,
        18: 23.05,
      },
    ],
  },
  {
    _id: '123456799',
    name: 'Mahomes, Patrick KCC QB',
    pts: 650.3,
    age: 26,
    team: 'Paradise Block Hawks',
    bye: 8,
    playerCap: 35793382,
    playerRank: '04',
    data: [
      {
        1: 54.95,
        2: 28.75,
        3: 26.3,
        4: 38.55,
        5: 47.8,
        6: 32.6,
        7: 42.15,
        8: 8,
        9: 50.1,
        10: 49.45,
        11: 41.35,
        12: 29.6,
        13: 27.55,
        14: 35.35,
        15: 48.05,
        16: 33.5,
        17: 41.2,
        18: 23.05,
      },
    ],
  },
  {
    _id: '1234567100',
    name: 'Mahomes, Patrick KCC QB',
    pts: 650.3,
    age: 26,
    team: 'Paradise Block Hawks',
    bye: 8,
    playerCap: 35793382,
    playerRank: '04',
    data: [
      {
        1: 54.95,
        2: 28.75,
        3: 26.3,
        4: 38.55,
        5: 47.8,
        6: 32.6,
        7: 42.15,
        8: 8,
        9: 50.1,
        10: 49.45,
        11: 41.35,
        12: 29.6,
        13: 27.55,
        14: 35.35,
        15: 48.05,
        16: 33.5,
        17: 41.2,
        18: 23.05,
      },
    ],
  },
  {
    _id: '1234567101',
    name: 'Mahomes, Patrick KCC QB',
    pts: 650.3,
    age: 26,
    team: 'Paradise Block Hawks',
    bye: 8,
    playerCap: 35793382,
    playerRank: '04',
    data: [
      {
        1: 54.95,
        2: 28.75,
        3: 26.3,
        4: 38.55,
        5: 47.8,
        6: 32.6,
        7: 42.15,
        8: 8,
        9: 50.1,
        10: 49.45,
        11: 41.35,
        12: 29.6,
        13: 27.55,
        14: 35.35,
        15: 48.05,
        16: 33.5,
        17: 41.2,
        18: 23.05,
      },
    ],
  },
  {
    _id: '1234567102',
    name: 'Mahomes, Patrick KCC QB',
    pts: 650.3,
    age: 26,
    team: 'Paradise Block Hawks',
    bye: 8,
    playerCap: 35793382,
    playerRank: '04',
    data: [
      {
        1: 54.95,
        2: 28.75,
        3: 26.3,
        4: 38.55,
        5: 47.8,
        6: 32.6,
        7: 42.15,
        8: 8,
        9: 50.1,
        10: 49.45,
        11: 41.35,
        12: 29.6,
        13: 27.55,
        14: 35.35,
        15: 48.05,
        16: 33.5,
        17: 41.2,
        18: 23.05,
      },
    ],
  },
  {
    _id: '1234567103',
    name: 'Mahomes, Patrick KCC QB',
    pts: 650.3,
    age: 26,
    team: 'Paradise Block Hawks',
    bye: 8,
    playerCap: 35793382,
    playerRank: '04',
    data: [
      {
        1: 54.95,
        2: 28.75,
        3: 26.3,
        4: 38.55,
        5: 47.8,
        6: 32.6,
        7: 42.15,
        8: 8,
        9: 50.1,
        10: 49.45,
        11: 41.35,
        12: 29.6,
        13: 27.55,
        14: 35.35,
        15: 48.05,
        16: 33.5,
        17: 41.2,
        18: 23.05,
      },
    ],
  },
  {
    _id: '1234567104',
    name: 'Mahomes, Patrick KCC QB',
    pts: 650.3,
    age: 26,
    team: 'Paradise Block Hawks',
    bye: 8,
    playerCap: 35793382,
    playerRank: '04',
    data: [
      {
        1: 54.95,
        2: 28.75,
        3: 26.3,
        4: 38.55,
        5: 47.8,
        6: 32.6,
        7: 42.15,
        8: 8,
        9: 50.1,
        10: 49.45,
        11: 41.35,
        12: 29.6,
        13: 27.55,
        14: 35.35,
        15: 48.05,
        16: 33.5,
        17: 41.2,
        18: 23.05,
      },
    ],
  },
  {
    _id: '1234567105',
    name: 'Mahomes, Patrick KCC QB',
    pts: 650.3,
    age: 26,
    team: 'Paradise Block Hawks',
    bye: 8,
    playerCap: 35793382,
    playerRank: '04',
    data: [
      {
        1: 54.95,
        2: 28.75,
        3: 26.3,
        4: 38.55,
        5: 47.8,
        6: 32.6,
        7: 42.15,
        8: 8,
        9: 50.1,
        10: 49.45,
        11: 41.35,
        12: 29.6,
        13: 27.55,
        14: 35.35,
        15: 48.05,
        16: 33.5,
        17: 41.2,
        18: 23.05,
      },
    ],
  },
  {
    _id: '1234567106',
    name: 'Mahomes, Patrick KCC QB',
    pts: 650.3,
    age: 26,
    team: 'Paradise Block Hawks',
    bye: 8,
    playerCap: 35793382,
    playerRank: '04',
    data: [
      {
        1: 54.95,
        2: 28.75,
        3: 26.3,
        4: 38.55,
        5: 47.8,
        6: 32.6,
        7: 42.15,
        8: 8,
        9: 50.1,
        10: 49.45,
        11: 41.35,
        12: 29.6,
        13: 27.55,
        14: 35.35,
        15: 48.05,
        16: 33.5,
        17: 41.2,
        18: 23.05,
      },
    ],
  },
  {
    _id: '1234567107',
    name: 'Mahomes, Patrick KCC QB',
    pts: 650.3,
    age: 26,
    team: 'Paradise Block Hawks',
    bye: 8,
    playerCap: 35793382,
    playerRank: '04',
    data: [
      {
        1: 54.95,
        2: 28.75,
        3: 26.3,
        4: 38.55,
        5: 47.8,
        6: 32.6,
        7: 42.15,
        8: 8,
        9: 50.1,
        10: 49.45,
        11: 41.35,
        12: 29.6,
        13: 27.55,
        14: 35.35,
        15: 48.05,
        16: 33.5,
        17: 41.2,
        18: 23.05,
      },
    ],
  },
  {
    _id: '1234567108',
    name: 'Mahomes, Patrick KCC QB',
    pts: 650.3,
    age: 26,
    team: 'Paradise Block Hawks',
    bye: 8,
    playerCap: 35793382,
    playerRank: '04',
    data: [
      {
        1: 54.95,
        2: 28.75,
        3: 26.3,
        4: 38.55,
        5: 47.8,
        6: 32.6,
        7: 42.15,
        8: 8,
        9: 50.1,
        10: 49.45,
        11: 41.35,
        12: 29.6,
        13: 27.55,
        14: 35.35,
        15: 48.05,
        16: 33.5,
        17: 41.2,
        18: 23.05,
      },
    ],
  },
  {
    _id: '1234567109',
    name: 'Mahomes, Patrick KCC QB',
    pts: 650.3,
    age: 26,
    team: 'Paradise Block Hawks',
    bye: 8,
    playerCap: 35793382,
    playerRank: '04',
    data: [
      {
        1: 54.95,
        2: 28.75,
        3: 26.3,
        4: 38.55,
        5: 47.8,
        6: 32.6,
        7: 42.15,
        8: 8,
        9: 50.1,
        10: 49.45,
        11: 41.35,
        12: 29.6,
        13: 27.55,
        14: 35.35,
        15: 48.05,
        16: 33.5,
        17: 41.2,
        18: 23.05,
      },
    ],
  },
  {
    _id: '1234567110',
    name: 'Mahomes, Patrick KCC QB',
    pts: 650.3,
    age: 26,
    team: 'Paradise Block Hawks',
    bye: 8,
    playerCap: 35793382,
    playerRank: '04',
    data: [
      {
        1: 54.95,
        2: 28.75,
        3: 26.3,
        4: 38.55,
        5: 47.8,
        6: 32.6,
        7: 42.15,
        8: 8,
        9: 50.1,
        10: 49.45,
        11: 41.35,
        12: 29.6,
        13: 27.55,
        14: 35.35,
        15: 48.05,
        16: 33.5,
        17: 41.2,
        18: 23.05,
      },
    ],
  },
  {
    _id: '1234567110',
    name: 'Mahomes, Patrick KCC QB',
    pts: 650.3,
    age: 26,
    team: 'Paradise Block Hawks',
    bye: 8,
    playerCap: 35793382,
    playerRank: '04',
    data: [
      {
        1: 54.95,
        2: 28.75,
        3: 26.3,
        4: 38.55,
        5: 47.8,
        6: 32.6,
        7: 42.15,
        8: 8,
        9: 50.1,
        10: 49.45,
        11: 41.35,
        12: 29.6,
        13: 27.55,
        14: 35.35,
        15: 48.05,
        16: 33.5,
        17: 41.2,
        18: 23.05,
      },
    ],
  },
  {
    _id: '1234567111',
    name: 'Mahomes, Patrick KCC QB',
    pts: 650.3,
    age: 26,
    team: 'Paradise Block Hawks',
    bye: 8,
    playerCap: 35793382,
    playerRank: '04',
    data: [
      {
        1: 54.95,
        2: 28.75,
        3: 26.3,
        4: 38.55,
        5: 47.8,
        6: 32.6,
        7: 42.15,
        8: 8,
        9: 50.1,
        10: 49.45,
        11: 41.35,
        12: 29.6,
        13: 27.55,
        14: 35.35,
        15: 48.05,
        16: 33.5,
        17: 41.2,
        18: 23.05,
      },
    ],
  },
  {
    _id: '1234567112',
    name: 'Mahomes, Patrick KCC QB',
    pts: 650.3,
    age: 26,
    team: 'Paradise Block Hawks',
    bye: 8,
    playerCap: 35793382,
    playerRank: '04',
    data: [
      {
        1: 54.95,
        2: 28.75,
        3: 26.3,
        4: 38.55,
        5: 47.8,
        6: 32.6,
        7: 42.15,
        8: 8,
        9: 50.1,
        10: 49.45,
        11: 41.35,
        12: 29.6,
        13: 27.55,
        14: 35.35,
        15: 48.05,
        16: 33.5,
        17: 41.2,
        18: 23.05,
      },
    ],
  },
  {
    _id: '1234567123',
    name: 'Mahomes, Patrick KCC QB',
    pts: 650.3,
    age: 26,
    team: 'Paradise Block Hawks',
    bye: 8,
    playerCap: 35793382,
    playerRank: '04',
    data: [
      {
        1: 54.95,
        2: 28.75,
        3: 26.3,
        4: 38.55,
        5: 47.8,
        6: 32.6,
        7: 42.15,
        8: 8,
        9: 50.1,
        10: 49.45,
        11: 41.35,
        12: 29.6,
        13: 27.55,
        14: 35.35,
        15: 48.05,
        16: 33.5,
        17: 41.2,
        18: 23.05,
      },
    ],
  },
  {
    _id: '1234567114',
    name: 'Mahomes, Patrick KCC QB',
    pts: 650.3,
    age: 26,
    team: 'Paradise Block Hawks',
    bye: 8,
    playerCap: 35793382,
    playerRank: '04',
    data: [
      {
        1: 54.95,
        2: 28.75,
        3: 26.3,
        4: 38.55,
        5: 47.8,
        6: 32.6,
        7: 42.15,
        8: 8,
        9: 50.1,
        10: 49.45,
        11: 41.35,
        12: 29.6,
        13: 27.55,
        14: 35.35,
        15: 48.05,
        16: 33.5,
        17: 41.2,
        18: 23.05,
      },
    ],
  },
  {
    _id: '1234567115',
    name: 'Mahomes, Patrick KCC QB',
    pts: 650.3,
    age: 26,
    team: 'Paradise Block Hawks',
    bye: 8,
    playerCap: 35793382,
    playerRank: '04',
    data: [
      {
        1: 54.95,
        2: 28.75,
        3: 26.3,
        4: 38.55,
        5: 47.8,
        6: 32.6,
        7: 42.15,
        8: 8,
        9: 50.1,
        10: 49.45,
        11: 41.35,
        12: 29.6,
        13: 27.55,
        14: 35.35,
        15: 48.05,
        16: 33.5,
        17: 41.2,
        18: 23.05,
      },
    ],
  },
]

export const playerRosterSquadData = [
  {
    _id: '123456781',
    name: 'Mahomes, Patrick KCC QB',
    pts: 650.3,
    age: 26,
    team: 'Paradise Block Hawks',
    bye: 8,
    playerCap: 35793382,
    playerRank: '04',
    data: [
      {
        1: 54.95,
        2: 28.75,
        3: 26.3,
        4: 38.55,
        5: 47.8,
        6: 32.6,
        7: 42.15,
        8: 8,
        9: 50.1,
        10: 49.45,
        11: 41.35,
        12: 29.6,
        13: 27.55,
        14: 35.35,
        15: 48.05,
        16: 33.5,
        17: 41.2,
        18: 23.05,
      },
    ],
  },
  {
    _id: '123456782',
    name: 'Mahomes, Patrick KCC QB',
    pts: 650.3,
    age: 26,
    team: 'Paradise Block Hawks',
    bye: 8,
    playerCap: 35793382,
    playerRank: '04',
    data: [
      {
        1: 54.95,
        2: 28.75,
        3: 26.3,
        4: 38.55,
        5: 47.8,
        6: 32.6,
        7: 42.15,
        8: 8,
        9: 50.1,
        10: 49.45,
        11: 41.35,
        12: 29.6,
        13: 27.55,
        14: 35.35,
        15: 48.05,
        16: 33.5,
        17: 41.2,
        18: 23.05,
      },
    ],
  },
  {
    _id: '123456783',
    name: 'Mahomes, Patrick KCC QB',
    pts: 650.3,
    age: 26,
    team: 'Paradise Block Hawks',
    bye: 8,
    playerCap: 35793382,
    playerRank: '04',
    data: [
      {
        1: 54.95,
        2: 28.75,
        3: 26.3,
        4: 38.55,
        5: 47.8,
        6: 32.6,
        7: 42.15,
        8: 8,
        9: 50.1,
        10: 49.45,
        11: 41.35,
        12: 29.6,
        13: 27.55,
        14: 35.35,
        15: 48.05,
        16: 33.5,
        17: 41.2,
        18: 23.05,
      },
    ],
  },
  {
    _id: '123456784',
    name: 'Mahomes, Patrick KCC QB',
    pts: 650.3,
    age: 26,
    team: 'Paradise Block Hawks',
    bye: 8,
    playerCap: 35793382,
    playerRank: '04',
    data: [
      {
        1: 54.95,
        2: 28.75,
        3: 26.3,
        4: 38.55,
        5: 47.8,
        6: 32.6,
        7: 42.15,
        8: 8,
        9: 50.1,
        10: 49.45,
        11: 41.35,
        12: 29.6,
        13: 27.55,
        14: 35.35,
        15: 48.05,
        16: 33.5,
        17: 41.2,
        18: 23.05,
      },
    ],
  },
  {
    _id: '123456785',
    name: 'Mahomes, Patrick KCC QB',
    pts: 650.3,
    age: 26,
    team: 'Paradise Block Hawks',
    bye: 8,
    playerCap: 35793382,
    playerRank: '04',
    data: [
      {
        1: 54.95,
        2: 28.75,
        3: 26.3,
        4: 38.55,
        5: 47.8,
        6: 32.6,
        7: 42.15,
        8: 8,
        9: 50.1,
        10: 49.45,
        11: 41.35,
        12: 29.6,
        13: 27.55,
        14: 35.35,
        15: 48.05,
        16: 33.5,
        17: 41.2,
        18: 23.05,
      },
    ],
  },
  {
    _id: '123456786',
    name: 'Mahomes, Patrick KCC QB',
    pts: 650.3,
    age: 26,
    team: 'Paradise Block Hawks',
    bye: 8,
    playerCap: 35793382,
    playerRank: '04',
    data: [
      {
        1: 54.95,
        2: 28.75,
        3: 26.3,
        4: 38.55,
        5: 47.8,
        6: 32.6,
        7: 42.15,
        8: 8,
        9: 50.1,
        10: 49.45,
        11: 41.35,
        12: 29.6,
        13: 27.55,
        14: 35.35,
        15: 48.05,
        16: 33.5,
        17: 41.2,
        18: 23.05,
      },
    ],
  },
  {
    _id: '123456787',
    name: 'Mahomes, Patrick KCC QB',
    pts: 650.3,
    age: 26,
    team: 'Paradise Block Hawks',
    bye: 8,
    playerCap: 35793382,
    playerRank: '04',
    data: [
      {
        1: 54.95,
        2: 28.75,
        3: 26.3,
        4: 38.55,
        5: 47.8,
        6: 32.6,
        7: 42.15,
        8: 8,
        9: 50.1,
        10: 49.45,
        11: 41.35,
        12: 29.6,
        13: 27.55,
        14: 35.35,
        15: 48.05,
        16: 33.5,
        17: 41.2,
        18: 23.05,
      },
    ],
  },
]

export const leagueStandingData = [
  {
    mainTitle: 'The Manning Conference - North',
    data: [
      {
        imageUrl: require('../assets/dragons-red-zone-square-1.png'),
        title: 'Red Zone Dragons',
        tableData: [
          {
            key: '1',
            wlt: '8-9-0',
            pct: '.471',
            gb: '3.0',
            strk: 'W1',
            pf: '4686.125',
            avgpf: '260.3',
            pa: '4919.300',
            avgpa: '289.4',
            divwlt: '4-2-0',
            confwlt: '6-6-0',
          },
        ],
      },
      {
        imageUrl: require('../assets/pradise.png'),
        title: 'Red Zone Dragons',
        tableData: [
          {
            key: '1',
            wlt: '8-9-0',
            pct: '.471',
            gb: '3.0',
            strk: 'W1',
            pf: '4686.125',
            avgpf: '260.3',
            pa: '4919.300',
            avgpa: '289.4',
            divwlt: '4-2-0',
            confwlt: '6-6-0',
          },
        ],
      },
      {
        imageUrl: require('../assets/timber.png'),
        title: 'Red Zone Dragons',
        tableData: [
          {
            key: '1',
            wlt: '8-9-0',
            pct: '.471',
            gb: '3.0',
            strk: 'W1',
            pf: '4686.125',
            avgpf: '260.3',
            pa: '4919.300',
            avgpa: '289.4',
            divwlt: '4-2-0',
            confwlt: '6-6-0',
          },
        ],
      },
      {
        imageUrl: require('../assets/surfdogs.png'),
        title: 'Red Zone Dragons',
        tableData: [
          {
            key: '1',
            wlt: '8-9-0',
            pct: '.471',
            gb: '3.0',
            strk: 'W1',
            pf: '4686.125',
            avgpf: '260.3',
            pa: '4919.300',
            avgpa: '289.4',
            divwlt: '4-2-0',
            confwlt: '6-6-0',
          },
        ],
      },
    ],
  },
  {
    mainTitle: 'The Manning Conference - EAST',
    data: [
      {
        imageUrl: require('../assets/dragons-red-zone-square-1.png'),
        title: 'Doom',
        tableData: [
          {
            key: '1',
            wlt: '8-9-0',
            pct: '.471',
            gb: '3.0',
            strk: 'W1',
            pf: '4686.125',
            avgpf: '260.3',
            pa: '4919.300',
            avgpa: '289.4',
            divwlt: '4-2-0',
            confwlt: '6-6-0',
          },
        ],
      },
      {
        imageUrl: require('../assets/pradise.png'),
        title: 'GRIDIRON SEALS',
        tableData: [
          {
            key: '1',
            wlt: '8-9-0',
            pct: '.471',
            gb: '3.0',
            strk: 'W1',
            pf: '4686.125',
            avgpf: '260.3',
            pa: '4919.300',
            avgpa: '289.4',
            divwlt: '4-2-0',
            confwlt: '6-6-0',
          },
        ],
      },
      {
        imageUrl: require('../assets/timber.png'),
        title: 'TIGER SHARKS',
        tableData: [
          {
            key: '1',
            wlt: '8-9-0',
            pct: '.471',
            gb: '3.0',
            strk: 'W1',
            pf: '4686.125',
            avgpf: '260.3',
            pa: '4919.300',
            avgpa: '289.4',
            divwlt: '4-2-0',
            confwlt: '6-6-0',
          },
        ],
      },
      {
        imageUrl: require('../assets/surfdogs.png'),
        title: 'TURF MONSTERS',
        tableData: [
          {
            key: '1',
            wlt: '8-9-0',
            pct: '.471',
            gb: '3.0',
            strk: 'W1',
            pf: '4686.125',
            avgpf: '260.3',
            pa: '4919.300',
            avgpa: '289.4',
            divwlt: '4-2-0',
            confwlt: '6-6-0',
          },
        ],
      },
    ],
  },
  {
    mainTitle: 'The Manning Conference - South',
    data: [
      {
        imageUrl: require('../assets/dragons-red-zone-square-1.png'),
        title: 'Red Zone Dragons',
        tableData: [
          {
            key: '1',
            wlt: '8-9-0',
            pct: '.471',
            gb: '3.0',
            strk: 'W1',
            pf: '4686.125',
            avgpf: '260.3',
            pa: '4919.300',
            avgpa: '289.4',
            divwlt: '4-2-0',
            confwlt: '6-6-0',
          },
        ],
      },
      {
        imageUrl: require('../assets/pradise.png'),
        title: 'Red Zone Dragons',
        tableData: [
          {
            key: '1',
            wlt: '8-9-0',
            pct: '.471',
            gb: '3.0',
            strk: 'W1',
            pf: '4686.125',
            avgpf: '260.3',
            pa: '4919.300',
            avgpa: '289.4',
            divwlt: '4-2-0',
            confwlt: '6-6-0',
          },
        ],
      },
      {
        imageUrl: require('../assets/timber.png'),
        title: 'Red Zone Dragons',
        tableData: [
          {
            key: '1',
            wlt: '8-9-0',
            pct: '.471',
            gb: '3.0',
            strk: 'W1',
            pf: '4686.125',
            avgpf: '260.3',
            pa: '4919.300',
            avgpa: '289.4',
            divwlt: '4-2-0',
            confwlt: '6-6-0',
          },
        ],
      },
      {
        imageUrl: require('../assets/surfdogs.png'),
        title: 'Red Zone Dragons',
        tableData: [
          {
            key: '1',
            wlt: '8-9-0',
            pct: '.471',
            gb: '3.0',
            strk: 'W1',
            pf: '4686.125',
            avgpf: '260.3',
            pa: '4919.300',
            avgpa: '289.4',
            divwlt: '4-2-0',
            confwlt: '6-6-0',
          },
        ],
      },
    ],
  },
  {
    mainTitle: 'The Manning Conference - West',
    data: [
      {
        imageUrl: require('../assets/dragons-red-zone-square-1.png'),
        title: 'Red Zone Dragons',
        tableData: [
          {
            key: '1',
            wlt: '8-9-0',
            pct: '.471',
            gb: '3.0',
            strk: 'W1',
            pf: '4686.125',
            avgpf: '260.3',
            pa: '4919.300',
            avgpa: '289.4',
            divwlt: '4-2-0',
            confwlt: '6-6-0',
          },
        ],
      },
      {
        imageUrl: require('../assets/pradise.png'),
        title: 'Red Zone Dragons',
        tableData: [
          {
            key: '1',
            wlt: '8-9-0',
            pct: '.471',
            gb: '3.0',
            strk: 'W1',
            pf: '4686.125',
            avgpf: '260.3',
            pa: '4919.300',
            avgpa: '289.4',
            divwlt: '4-2-0',
            confwlt: '6-6-0',
          },
        ],
      },
      {
        imageUrl: require('../assets/timber.png'),
        title: 'Red Zone Dragons',
        tableData: [
          {
            key: '1',
            wlt: '8-9-0',
            pct: '.471',
            gb: '3.0',
            strk: 'W1',
            pf: '4686.125',
            avgpf: '260.3',
            pa: '4919.300',
            avgpa: '289.4',
            divwlt: '4-2-0',
            confwlt: '6-6-0',
          },
        ],
      },
      {
        imageUrl: require('../assets/surfdogs.png'),
        title: 'Red Zone Dragons',
        tableData: [
          {
            key: '1',
            wlt: '8-9-0',
            pct: '.471',
            gb: '3.0',
            strk: 'W1',
            pf: '4686.125',
            avgpf: '260.3',
            pa: '4919.300',
            avgpa: '289.4',
            divwlt: '4-2-0',
            confwlt: '6-6-0',
          },
        ],
      },
    ],
  },
  {
    mainTitle: 'JOHN MADDEN Conference - North',
    data: [
      {
        imageUrl: require('../assets/dragons-red-zone-square-1.png'),
        title: 'Red Zone Dragons',
        tableData: [
          {
            key: '1',
            wlt: '8-9-0',
            pct: '.471',
            gb: '3.0',
            strk: 'W1',
            pf: '4686.125',
            avgpf: '260.3',
            pa: '4919.300',
            avgpa: '289.4',
            divwlt: '4-2-0',
            confwlt: '6-6-0',
          },
        ],
      },
      {
        imageUrl: require('../assets/pradise.png'),
        title: 'Red Zone Dragons',
        tableData: [
          {
            key: '1',
            wlt: '8-9-0',
            pct: '.471',
            gb: '3.0',
            strk: 'W1',
            pf: '4686.125',
            avgpf: '260.3',
            pa: '4919.300',
            avgpa: '289.4',
            divwlt: '4-2-0',
            confwlt: '6-6-0',
          },
        ],
      },
      {
        imageUrl: require('../assets/timber.png'),
        title: 'Red Zone Dragons',
        tableData: [
          {
            key: '1',
            wlt: '8-9-0',
            pct: '.471',
            gb: '3.0',
            strk: 'W1',
            pf: '4686.125',
            avgpf: '260.3',
            pa: '4919.300',
            avgpa: '289.4',
            divwlt: '4-2-0',
            confwlt: '6-6-0',
          },
        ],
      },
      {
        imageUrl: require('../assets/surfdogs.png'),
        title: 'Red Zone Dragons',
        tableData: [
          {
            key: '1',
            wlt: '8-9-0',
            pct: '.471',
            gb: '3.0',
            strk: 'W1',
            pf: '4686.125',
            avgpf: '260.3',
            pa: '4919.300',
            avgpa: '289.4',
            divwlt: '4-2-0',
            confwlt: '6-6-0',
          },
        ],
      },
    ],
  },
  {
    mainTitle: 'JOHN MADDEN Conference - East',
    data: [
      {
        imageUrl: require('../assets/dragons-red-zone-square-1.png'),
        title: 'Red Zone Dragons',
        tableData: [
          {
            key: '1',
            wlt: '8-9-0',
            pct: '.471',
            gb: '3.0',
            strk: 'W1',
            pf: '4686.125',
            avgpf: '260.3',
            pa: '4919.300',
            avgpa: '289.4',
            divwlt: '4-2-0',
            confwlt: '6-6-0',
          },
        ],
      },
      {
        imageUrl: require('../assets/pradise.png'),
        title: 'Red Zone Dragons',
        tableData: [
          {
            key: '1',
            wlt: '8-9-0',
            pct: '.471',
            gb: '3.0',
            strk: 'W1',
            pf: '4686.125',
            avgpf: '260.3',
            pa: '4919.300',
            avgpa: '289.4',
            divwlt: '4-2-0',
            confwlt: '6-6-0',
          },
        ],
      },
      {
        imageUrl: require('../assets/timber.png'),
        title: 'Red Zone Dragons',
        tableData: [
          {
            key: '1',
            wlt: '8-9-0',
            pct: '.471',
            gb: '3.0',
            strk: 'W1',
            pf: '4686.125',
            avgpf: '260.3',
            pa: '4919.300',
            avgpa: '289.4',
            divwlt: '4-2-0',
            confwlt: '6-6-0',
          },
        ],
      },
      {
        imageUrl: require('../assets/surfdogs.png'),
        title: 'Red Zone Dragons',
        tableData: [
          {
            key: '1',
            wlt: '8-9-0',
            pct: '.471',
            gb: '3.0',
            strk: 'W1',
            pf: '4686.125',
            avgpf: '260.3',
            pa: '4919.300',
            avgpa: '289.4',
            divwlt: '4-2-0',
            confwlt: '6-6-0',
          },
        ],
      },
    ],
  },
  {
    mainTitle: 'JOHN MADDEN Conference - South',
    data: [
      {
        imageUrl: require('../assets/dragons-red-zone-square-1.png'),
        title: 'Red Zone Dragons',
        tableData: [
          {
            key: '1',
            wlt: '8-9-0',
            pct: '.471',
            gb: '3.0',
            strk: 'W1',
            pf: '4686.125',
            avgpf: '260.3',
            pa: '4919.300',
            avgpa: '289.4',
            divwlt: '4-2-0',
            confwlt: '6-6-0',
          },
        ],
      },
      {
        imageUrl: require('../assets/pradise.png'),
        title: 'Red Zone Dragons',
        tableData: [
          {
            key: '1',
            wlt: '8-9-0',
            pct: '.471',
            gb: '3.0',
            strk: 'W1',
            pf: '4686.125',
            avgpf: '260.3',
            pa: '4919.300',
            avgpa: '289.4',
            divwlt: '4-2-0',
            confwlt: '6-6-0',
          },
        ],
      },
      {
        imageUrl: require('../assets/timber.png'),
        title: 'Red Zone Dragons',
        tableData: [
          {
            key: '1',
            wlt: '8-9-0',
            pct: '.471',
            gb: '3.0',
            strk: 'W1',
            pf: '4686.125',
            avgpf: '260.3',
            pa: '4919.300',
            avgpa: '289.4',
            divwlt: '4-2-0',
            confwlt: '6-6-0',
          },
        ],
      },
      {
        imageUrl: require('../assets/surfdogs.png'),
        title: 'Red Zone Dragons',
        tableData: [
          {
            key: '1',
            wlt: '8-9-0',
            pct: '.471',
            gb: '3.0',
            strk: 'W1',
            pf: '4686.125',
            avgpf: '260.3',
            pa: '4919.300',
            avgpa: '289.4',
            divwlt: '4-2-0',
            confwlt: '6-6-0',
          },
        ],
      },
    ],
  },
  {
    mainTitle: 'JOHN MADDEN Conference - West',
    data: [
      {
        imageUrl: require('../assets/dragons-red-zone-square-1.png'),
        title: 'Red Zone Dragons',
        tableData: [
          {
            key: '1',
            wlt: '8-9-0',
            pct: '.471',
            gb: '3.0',
            strk: 'W1',
            pf: '4686.125',
            avgpf: '260.3',
            pa: '4919.300',
            avgpa: '289.4',
            divwlt: '4-2-0',
            confwlt: '6-6-0',
          },
        ],
      },
      {
        imageUrl: require('../assets/pradise.png'),
        title: 'Red Zone Dragons',
        tableData: [
          {
            key: '1',
            wlt: '8-9-0',
            pct: '.471',
            gb: '3.0',
            strk: 'W1',
            pf: '4686.125',
            avgpf: '260.3',
            pa: '4919.300',
            avgpa: '289.4',
            divwlt: '4-2-0',
            confwlt: '6-6-0',
          },
        ],
      },
      {
        imageUrl: require('../assets/timber.png'),
        title: 'Red Zone Dragons',
        tableData: [
          {
            key: '1',
            wlt: '8-9-0',
            pct: '.471',
            gb: '3.0',
            strk: 'W1',
            pf: '4686.125',
            avgpf: '260.3',
            pa: '4919.300',
            avgpa: '289.4',
            divwlt: '4-2-0',
            confwlt: '6-6-0',
          },
        ],
      },
      {
        imageUrl: require('../assets/surfdogs.png'),
        title: 'Red Zone Dragons',
        tableData: [
          {
            key: '1',
            wlt: '8-9-0',
            pct: '.471',
            gb: '3.0',
            strk: 'W1',
            pf: '4686.125',
            avgpf: '260.3',
            pa: '4919.300',
            avgpa: '289.4',
            divwlt: '4-2-0',
            confwlt: '6-6-0',
          },
        ],
      },
    ],
  },
]

export const transactionData = [
  {
    key: 1,
    franchise: 'The Beast',
    type: 'Taxi Squad',
    transaction: ['Demoted Bolton, Nick KCC LB; White, Kyzir PHI LB'],
    date: new Date(),
  },
  {
    key: 2,
    franchise: 'Blockchain Bounty Hunters',
    type: 'Injured Reserve',
    transaction: ['Deactivated Boone, Mike DEN RB; Jackson, Donte CAR CB'],
    date: new Date(),
  },
  {
    key: 3,
    franchise: 'Blockchain Bounty Hunters',
    type: 'Taxi Squad',
    transaction: ['Promoted Kirkwood, Keith NOS WR; Robinson, Kenny PIT S,'],
    date: new Date(),
  },
  {
    key: 4,
    franchise: 'The Resistance (C)',
    type: 'Add/Drop',
    transaction: ['Demoted Bolton, Nick KCC LB; White, Kyzir PHI LB'],
    date: new Date(),
  },
  {
    key: 5,
    franchise: 'Red Zone Dragons',
    type: 'Taxi Squad',
    transaction: ['Demoted Bolton, Nick KCC LB; White, Kyzir PHI LB'],
    date: new Date(),
  },
  {
    key: 6,
    franchise: 'Red Zone Dragons',
    type: 'Taxi Squad',
    transaction: ['Demoted Bolton, Nick KCC LB; White, Kyzir PHI LB'],
    date: new Date(),
  },
  {
    key: 7,
    franchise: 'Red Zone Dragons',
    type: 'Taxi Squad',
    transaction: ['Promoted Lewis, Terrell CHI LB', 'Demoted Tuszka, Derrek LAC LB'],
    date: new Date(),
  },
  {
    key: 8,
    franchise: 'Kingsmen',
    type: 'Taxi Squad',
    transaction: ['Demoted Bolton, Nick KCC LB; White, Kyzir PHI LB'],
    date: new Date(),
  },
  {
    key: 9,
    franchise: 'Kingsmen',
    type: 'Taxi Squad',
    transaction: ['Demoted Bolton, Nick KCC LB; White, Kyzir PHI LB'],
    date: new Date(),
  },
  {
    key: 10,
    franchise: 'Empire',
    type: 'Taxi Squad',
    transaction: ['Demoted Bolton, Nick KCC LB; White, Kyzir PHI LB'],
    date: new Date(),
  },
  {
    key: 11,
    franchise: 'The Beast',
    type: 'Taxi Squad',
    transaction: ['Demoted Bolton, Nick KCC LB; White, Kyzir PHI LB'],
    date: new Date(),
  },
  {
    key: 12,
    franchise: 'Blockchain Bounty Hunters',
    type: 'Injured Reserve',
    transaction: ['Deactivated Boone, Mike DEN RB; Jackson, Donte CAR CB'],
    date: new Date(),
  },
  {
    key: 13,
    franchise: 'Blockchain Bounty Hunters',
    type: 'Taxi Squad',
    transaction: ['Promoted Kirkwood, Keith NOS WR; Robinson, Kenny PIT S,'],
    date: new Date(),
  },
  {
    key: 14,
    franchise: 'The Resistance (C)',
    type: 'Add/Drop',
    transaction: ['Demoted Bolton, Nick KCC LB; White, Kyzir PHI LB'],
    date: new Date(),
  },
  {
    key: 15,
    franchise: 'Red Zone Dragons',
    type: 'Taxi Squad',
    transaction: ['Demoted Bolton, Nick KCC LB; White, Kyzir PHI LB'],
    date: new Date(),
  },
  {
    key: 16,
    franchise: 'Red Zone Dragons',
    type: 'Taxi Squad',
    transaction: ['Demoted Bolton, Nick KCC LB; White, Kyzir PHI LB'],
    date: new Date(),
  },
  {
    key: 17,
    franchise: 'Red Zone Dragons',
    type: 'Taxi Squad',
    transaction: ['Promoted Lewis, Terrell CHI LB', 'Demoted Tuszka, Derrek LAC LB'],
    date: new Date(),
  },
  {
    key: 18,
    franchise: 'Kingsmen',
    type: 'Taxi Squad',
    transaction: ['Demoted Bolton, Nick KCC LB; White, Kyzir PHI LB'],
    date: new Date(),
  },
  {
    key: 19,
    franchise: 'Kingsmen',
    type: 'Taxi Squad',
    transaction: ['Demoted Bolton, Nick KCC LB; White, Kyzir PHI LB'],
    date: new Date(),
  },
  {
    key: 20,
    franchise: 'Empire',
    type: 'Taxi Squad',
    transaction: ['Demoted Bolton, Nick KCC LB; White, Kyzir PHI LB'],
    date: new Date(),
  },
  {
    key: 21,
    franchise: 'The Beast',
    type: 'Taxi Squad',
    transaction: ['Demoted Bolton, Nick KCC LB; White, Kyzir PHI LB'],
    date: new Date(),
  },
  {
    key: 22,
    franchise: 'Blockchain Bounty Hunters',
    type: 'Injured Reserve',
    transaction: ['Deactivated Boone, Mike DEN RB; Jackson, Donte CAR CB'],
    date: new Date(),
  },
  {
    key: 23,
    franchise: 'Blockchain Bounty Hunters',
    type: 'Taxi Squad',
    transaction: ['Promoted Kirkwood, Keith NOS WR; Robinson, Kenny PIT S,'],
    date: new Date(),
  },
  {
    key: 24,
    franchise: 'The Resistance (C)',
    type: 'Add/Drop',
    transaction: ['Demoted Bolton, Nick KCC LB; White, Kyzir PHI LB'],
    date: new Date(),
  },
  {
    key: 25,
    franchise: 'Red Zone Dragons',
    type: 'Taxi Squad',
    transaction: ['Demoted Bolton, Nick KCC LB; White, Kyzir PHI LB'],
    date: new Date(),
  },
  {
    key: 26,
    franchise: 'Red Zone Dragons',
    type: 'Taxi Squad',
    transaction: ['Demoted Bolton, Nick KCC LB; White, Kyzir PHI LB'],
    date: new Date(),
  },
  {
    key: 27,
    franchise: 'Red Zone Dragons',
    type: 'Taxi Squad',
    transaction: ['Promoted Lewis, Terrell CHI LB', 'Demoted Tuszka, Derrek LAC LB'],
    date: new Date(),
  },
  {
    key: 28,
    franchise: 'Kingsmen',
    type: 'Taxi Squad',
    transaction: ['Demoted Bolton, Nick KCC LB; White, Kyzir PHI LB'],
    date: new Date(),
  },
  {
    key: 29,
    franchise: 'Kingsmen',
    type: 'Taxi Squad',
    transaction: ['Demoted Bolton, Nick KCC LB; White, Kyzir PHI LB'],
    date: new Date(),
  },
  {
    key: 30,
    franchise: 'Empire',
    type: 'Taxi Squad',
    transaction: ['Demoted Bolton, Nick KCC LB; White, Kyzir PHI LB'],
    date: new Date(),
  },
]

export const liveScoreData = [
  {
    title: 'PARADISE BLACK HAWKS',
    starters: '',
    starter: 0,
    nonStarter: '',
  },
  {
    title: 'PARADISE BLACK HAWKS',
    starters: '',
    starter: 0,
    nonStarter: '',
  },
  {
    title: 'GRIDIRON SEALS',
    starters: '',
    starter: 0,
    nonStarter: '',
  },
  {
    title: 'GRIDIRON SEALS',
    starters: '',
    starter: 0,
    nonStarter: '',
  },
  {
    title: 'GRIDIRON SEALS',
    starters: '',
    starter: 0,
    nonStarter: '',
  },
  {
    title: 'GRIDIRON SEALS',
    starters: '',
    starter: 0,
    nonStarter: '',
  },
  {
    title: 'GRIDIRON SEALS',
    starters: '',
    starter: 0,
    nonStarter: '',
  },
  {
    title: 'GRIDIRON SEALS',
    starters: '',
    starter: 0,
    nonStarter: '',
  },
  {
    title: 'GRIDIRON SEALS',
    starters: '',
    starter: 0,
    nonStarter: '',
  },
  {
    title: 'GRIDIRON SEALS',
    starters: '',
    starter: 0,
    nonStarter: '',
  },
  {
    title: 'GRIDIRON SEALS',
    starters: '',
    starter: 0,
    nonStarter: '',
  },
  {
    title: 'GRIDIRON SEALS',
    starters: '',
    starter: 0,
    nonStarter: '',
  },
  {
    title: 'GRIDIRON SEALS',
    starters: '',
    starter: 0,
    nonStarter: '',
  },
  {
    title: 'GRIDIRON SEALS',
    starters: '',
    starter: 0,
    nonStarter: '',
  },
  {
    title: 'GRIDIRON SEALS',
    starters: '',
    starter: 0,
    nonStarter: '',
  },
  {
    title: 'GRIDIRON SEALS',
    starters: '',
    starter: 0,
    nonStarter: '',
  },
  {
    title: 'GRIDIRON SEALS',
    starters: '',
    starter: 0,
    nonStarter: '',
  },
  {
    title: 'GRIDIRON SEALS',
    starters: '',
    starter: 0,
    nonStarter: '',
  },
  {
    title: 'GRIDIRON SEALS',
    starters: '',
    starter: 0,
    nonStarter: '',
  },
  {
    title: 'GRIDIRON SEALS',
    starters: '',
    starter: 0,
    nonStarter: '',
  },
  {
    title: 'GRIDIRON SEALS',
    starters: '',
    starter: 0,
    nonStarter: '',
  },
  {
    title: 'GRIDIRON SEALS',
    starters: '',
    starter: 0,
    nonStarter: '',
  },
  {
    title: 'GRIDIRON SEALS',
    starters: '',
    starter: 0,
    nonStarter: '',
  },
  {
    title: 'GRIDIRON SEALS',
    starters: '',
    starter: 0,
    nonStarter: '',
  },
  {
    title: 'GRIDIRON SEALS',
    starters: '',
    starter: 0,
    nonStarter: '',
  },
  {
    title: 'GRIDIRON SEALS',
    starters: '',
    starter: 0,
    nonStarter: '',
  },
  {
    title: 'GRIDIRON SEALS',
    starters: '',
    starter: 0,
    nonStarter: '',
  },
  {
    title: 'GRIDIRON SEALS',
    starters: '',
    starter: 0,
    nonStarter: '',
  },
  {
    title: 'GRIDIRON SEALS',
    starters: '',
    starter: 0,
    nonStarter: '',
  },
  {
    title: 'GRIDIRON SEALS',
    starters: '',
    starter: 0,
    nonStarter: '',
  },
  {
    title: 'GRIDIRON SEALS',
    starters: '',
    starter: 0,
    nonStarter: '',
  },
  {
    title: 'GRIDIRON SEALS',
    starters: '',
    starter: 0,
    nonStarter: '',
  },
  {
    title: 'GRIDIRON SEALS',
    starters: '',
    starter: 0,
    nonStarter: '',
  },
  {
    title: 'GRIDIRON SEALS',
    starters: '',
    starter: 0,
    nonStarter: '',
  },
]

export const scheduleData = [
  {
    title: 'Week 1 Head-To-Head Results',
    data: [
      {
        team1: {
          matchup: 'Tiger Sharks',
          score: '295.475',
        },
        team2: {
          matchup: 'Doom',
          score: '325.900',
        },
      },
      {
        team1: {
          matchup: 'Paradise Black Hawks',
          score: '320.875',
        },
        team2: {
          matchup: 'SurfDogs',
          score: '238.150',
        },
      },
      {
        team1: {
          matchup: 'Heat Wave',
          score: '425.825',
        },
        team2: {
          matchup: 'GhostRiders',
          score: '191.650',
        },
      },
      {
        team1: {
          matchup: 'Paradise Black Hawks',
          score: '320.875',
        },
        team2: {
          matchup: 'SurfDogs',
          score: '238.150',
        },
      },
      {
        team1: {
          matchup: 'Tiger Sharks',
          score: '295.475',
        },
        team2: {
          matchup: 'Doom',
          score: '325.900',
        },
      },
      {
        team1: {
          matchup: 'Paradise Black Hawks',
          score: '320.875',
        },
        team2: {
          matchup: 'SurfDogs',
          score: '238.150',
        },
      },
      {
        team1: {
          matchup: 'Heat Wave',
          score: '425.825',
        },
        team2: {
          matchup: 'GhostRiders',
          score: '191.650',
        },
      },
      {
        team1: {
          matchup: 'Paradise Black Hawks',
          score: '320.875',
        },
        team2: {
          matchup: 'SurfDogs',
          score: '238.150',
        },
      },
      {
        team1: {
          matchup: 'Tiger Sharks',
          score: '295.475',
        },
        team2: {
          matchup: 'Doom',
          score: '325.900',
        },
      },
      {
        team1: {
          matchup: 'Heat Wave',
          score: '425.825',
        },
        team2: {
          matchup: 'GhostRiders',
          score: '191.650',
        },
      },
      {
        team1: {
          matchup: 'Paradise Black Hawks',
          score: '320.875',
        },
        team2: {
          matchup: 'SurfDogs',
          score: '238.150',
        },
      },
      {
        team1: {
          matchup: 'Tiger Sharks',
          score: '295.475',
        },
        team2: {
          matchup: 'Doom',
          score: '325.900',
        },
      },
      {
        team1: {
          matchup: 'Paradise Black Hawks',
          score: '320.875',
        },
        team2: {
          matchup: 'SurfDogs',
          score: '238.150',
        },
      },
      {
        team1: {
          matchup: 'Heat Wave',
          score: '425.825',
        },
        team2: {
          matchup: 'GhostRiders',
          score: '191.650',
        },
      },
      {
        team1: {
          matchup: 'Paradise Black Hawks',
          score: '320.875',
        },
        team2: {
          matchup: 'SurfDogs',
          score: '238.150',
        },
      },
      {
        team1: {
          matchup: 'Tiger Sharks',
          score: '295.475',
        },
        team2: {
          matchup: 'Doom',
          score: '325.900',
        },
      },
    ],
  },
  {
    title: 'Week 1 Head-To-Head Results',
    data: [
      {
        team1: {
          matchup: 'Tiger Sharks',
          score: '295.475',
        },
        team2: {
          matchup: 'Doom',
          score: '325.900',
        },
      },
      {
        team1: {
          matchup: 'Paradise Black Hawks',
          score: '320.875',
        },
        team2: {
          matchup: 'SurfDogs',
          score: '238.150',
        },
      },
      {
        team1: {
          matchup: 'Heat Wave',
          score: '425.825',
        },
        team2: {
          matchup: 'GhostRiders',
          score: '191.650',
        },
      },
      {
        team1: {
          matchup: 'Paradise Black Hawks',
          score: '320.875',
        },
        team2: {
          matchup: 'SurfDogs',
          score: '238.150',
        },
      },
      {
        team1: {
          matchup: 'Tiger Sharks',
          score: '295.475',
        },
        team2: {
          matchup: 'Doom',
          score: '325.900',
        },
      },
      {
        team1: {
          matchup: 'Paradise Black Hawks',
          score: '320.875',
        },
        team2: {
          matchup: 'SurfDogs',
          score: '238.150',
        },
      },
      {
        team1: {
          matchup: 'Heat Wave',
          score: '425.825',
        },
        team2: {
          matchup: 'GhostRiders',
          score: '191.650',
        },
      },
      {
        team1: {
          matchup: 'Paradise Black Hawks',
          score: '320.875',
        },
        team2: {
          matchup: 'SurfDogs',
          score: '238.150',
        },
      },
      {
        team1: {
          matchup: 'Tiger Sharks',
          score: '295.475',
        },
        team2: {
          matchup: 'Doom',
          score: '325.900',
        },
      },
      {
        team1: {
          matchup: 'Heat Wave',
          score: '425.825',
        },
        team2: {
          matchup: 'GhostRiders',
          score: '191.650',
        },
      },
      {
        team1: {
          matchup: 'Paradise Black Hawks',
          score: '320.875',
        },
        team2: {
          matchup: 'SurfDogs',
          score: '238.150',
        },
      },
      {
        team1: {
          matchup: 'Tiger Sharks',
          score: '295.475',
        },
        team2: {
          matchup: 'Doom',
          score: '325.900',
        },
      },
      {
        team1: {
          matchup: 'Paradise Black Hawks',
          score: '320.875',
        },
        team2: {
          matchup: 'SurfDogs',
          score: '238.150',
        },
      },
      {
        team1: {
          matchup: 'Heat Wave',
          score: '425.825',
        },
        team2: {
          matchup: 'GhostRiders',
          score: '191.650',
        },
      },
      {
        team1: {
          matchup: 'Paradise Black Hawks',
          score: '320.875',
        },
        team2: {
          matchup: 'SurfDogs',
          score: '238.150',
        },
      },
      {
        team1: {
          matchup: 'Tiger Sharks',
          score: '295.475',
        },
        team2: {
          matchup: 'Doom',
          score: '325.900',
        },
      },
    ],
  },
  {
    title: 'Week 1 Head-To-Head Results',
    data: [
      {
        team1: {
          matchup: 'Tiger Sharks',
          score: '295.475',
        },
        team2: {
          matchup: 'Doom',
          score: '325.900',
        },
      },
      {
        team1: {
          matchup: 'Paradise Black Hawks',
          score: '320.875',
        },
        team2: {
          matchup: 'SurfDogs',
          score: '238.150',
        },
      },
      {
        team1: {
          matchup: 'Heat Wave',
          score: '425.825',
        },
        team2: {
          matchup: 'GhostRiders',
          score: '191.650',
        },
      },
      {
        team1: {
          matchup: 'Paradise Black Hawks',
          score: '320.875',
        },
        team2: {
          matchup: 'SurfDogs',
          score: '238.150',
        },
      },
      {
        team1: {
          matchup: 'Tiger Sharks',
          score: '295.475',
        },
        team2: {
          matchup: 'Doom',
          score: '325.900',
        },
      },
      {
        team1: {
          matchup: 'Paradise Black Hawks',
          score: '320.875',
        },
        team2: {
          matchup: 'SurfDogs',
          score: '238.150',
        },
      },
      {
        team1: {
          matchup: 'Heat Wave',
          score: '425.825',
        },
        team2: {
          matchup: 'GhostRiders',
          score: '191.650',
        },
      },
      {
        team1: {
          matchup: 'Paradise Black Hawks',
          score: '320.875',
        },
        team2: {
          matchup: 'SurfDogs',
          score: '238.150',
        },
      },
      {
        team1: {
          matchup: 'Tiger Sharks',
          score: '295.475',
        },
        team2: {
          matchup: 'Doom',
          score: '325.900',
        },
      },
      {
        team1: {
          matchup: 'Heat Wave',
          score: '425.825',
        },
        team2: {
          matchup: 'GhostRiders',
          score: '191.650',
        },
      },
      {
        team1: {
          matchup: 'Paradise Black Hawks',
          score: '320.875',
        },
        team2: {
          matchup: 'SurfDogs',
          score: '238.150',
        },
      },
      {
        team1: {
          matchup: 'Tiger Sharks',
          score: '295.475',
        },
        team2: {
          matchup: 'Doom',
          score: '325.900',
        },
      },
      {
        team1: {
          matchup: 'Paradise Black Hawks',
          score: '320.875',
        },
        team2: {
          matchup: 'SurfDogs',
          score: '238.150',
        },
      },
      {
        team1: {
          matchup: 'Heat Wave',
          score: '425.825',
        },
        team2: {
          matchup: 'GhostRiders',
          score: '191.650',
        },
      },
      {
        team1: {
          matchup: 'Paradise Black Hawks',
          score: '320.875',
        },
        team2: {
          matchup: 'SurfDogs',
          score: '238.150',
        },
      },
      {
        team1: {
          matchup: 'Tiger Sharks',
          score: '295.475',
        },
        team2: {
          matchup: 'Doom',
          score: '325.900',
        },
      },
    ],
  },
  {
    title: 'Week 1 Head-To-Head Results',
    data: [
      {
        team1: {
          matchup: 'Tiger Sharks',
          score: '295.475',
        },
        team2: {
          matchup: 'Doom',
          score: '325.900',
        },
      },
      {
        team1: {
          matchup: 'Paradise Black Hawks',
          score: '320.875',
        },
        team2: {
          matchup: 'SurfDogs',
          score: '238.150',
        },
      },
      {
        team1: {
          matchup: 'Heat Wave',
          score: '425.825',
        },
        team2: {
          matchup: 'GhostRiders',
          score: '191.650',
        },
      },
      {
        team1: {
          matchup: 'Paradise Black Hawks',
          score: '320.875',
        },
        team2: {
          matchup: 'SurfDogs',
          score: '238.150',
        },
      },
      {
        team1: {
          matchup: 'Tiger Sharks',
          score: '295.475',
        },
        team2: {
          matchup: 'Doom',
          score: '325.900',
        },
      },
      {
        team1: {
          matchup: 'Paradise Black Hawks',
          score: '320.875',
        },
        team2: {
          matchup: 'SurfDogs',
          score: '238.150',
        },
      },
      {
        team1: {
          matchup: 'Heat Wave',
          score: '425.825',
        },
        team2: {
          matchup: 'GhostRiders',
          score: '191.650',
        },
      },
      {
        team1: {
          matchup: 'Paradise Black Hawks',
          score: '320.875',
        },
        team2: {
          matchup: 'SurfDogs',
          score: '238.150',
        },
      },
      {
        team1: {
          matchup: 'Tiger Sharks',
          score: '295.475',
        },
        team2: {
          matchup: 'Doom',
          score: '325.900',
        },
      },
      {
        team1: {
          matchup: 'Heat Wave',
          score: '425.825',
        },
        team2: {
          matchup: 'GhostRiders',
          score: '191.650',
        },
      },
      {
        team1: {
          matchup: 'Paradise Black Hawks',
          score: '320.875',
        },
        team2: {
          matchup: 'SurfDogs',
          score: '238.150',
        },
      },
      {
        team1: {
          matchup: 'Tiger Sharks',
          score: '295.475',
        },
        team2: {
          matchup: 'Doom',
          score: '325.900',
        },
      },
      {
        team1: {
          matchup: 'Paradise Black Hawks',
          score: '320.875',
        },
        team2: {
          matchup: 'SurfDogs',
          score: '238.150',
        },
      },
      {
        team1: {
          matchup: 'Heat Wave',
          score: '425.825',
        },
        team2: {
          matchup: 'GhostRiders',
          score: '191.650',
        },
      },
      {
        team1: {
          matchup: 'Paradise Black Hawks',
          score: '320.875',
        },
        team2: {
          matchup: 'SurfDogs',
          score: '238.150',
        },
      },
      {
        team1: {
          matchup: 'Tiger Sharks',
          score: '295.475',
        },
        team2: {
          matchup: 'Doom',
          score: '325.900',
        },
      },
    ],
  },
  {
    title: 'Week 1 Head-To-Head Results',
    data: [
      {
        team1: {
          matchup: 'Tiger Sharks',
          score: '295.475',
        },
        team2: {
          matchup: 'Doom',
          score: '325.900',
        },
      },
      {
        team1: {
          matchup: 'Paradise Black Hawks',
          score: '320.875',
        },
        team2: {
          matchup: 'SurfDogs',
          score: '238.150',
        },
      },
      {
        team1: {
          matchup: 'Heat Wave',
          score: '425.825',
        },
        team2: {
          matchup: 'GhostRiders',
          score: '191.650',
        },
      },
      {
        team1: {
          matchup: 'Paradise Black Hawks',
          score: '320.875',
        },
        team2: {
          matchup: 'SurfDogs',
          score: '238.150',
        },
      },
      {
        team1: {
          matchup: 'Tiger Sharks',
          score: '295.475',
        },
        team2: {
          matchup: 'Doom',
          score: '325.900',
        },
      },
      {
        team1: {
          matchup: 'Paradise Black Hawks',
          score: '320.875',
        },
        team2: {
          matchup: 'SurfDogs',
          score: '238.150',
        },
      },
      {
        team1: {
          matchup: 'Heat Wave',
          score: '425.825',
        },
        team2: {
          matchup: 'GhostRiders',
          score: '191.650',
        },
      },
      {
        team1: {
          matchup: 'Paradise Black Hawks',
          score: '320.875',
        },
        team2: {
          matchup: 'SurfDogs',
          score: '238.150',
        },
      },
      {
        team1: {
          matchup: 'Tiger Sharks',
          score: '295.475',
        },
        team2: {
          matchup: 'Doom',
          score: '325.900',
        },
      },
      {
        team1: {
          matchup: 'Heat Wave',
          score: '425.825',
        },
        team2: {
          matchup: 'GhostRiders',
          score: '191.650',
        },
      },
      {
        team1: {
          matchup: 'Paradise Black Hawks',
          score: '320.875',
        },
        team2: {
          matchup: 'SurfDogs',
          score: '238.150',
        },
      },
      {
        team1: {
          matchup: 'Tiger Sharks',
          score: '295.475',
        },
        team2: {
          matchup: 'Doom',
          score: '325.900',
        },
      },
      {
        team1: {
          matchup: 'Paradise Black Hawks',
          score: '320.875',
        },
        team2: {
          matchup: 'SurfDogs',
          score: '238.150',
        },
      },
      {
        team1: {
          matchup: 'Heat Wave',
          score: '425.825',
        },
        team2: {
          matchup: 'GhostRiders',
          score: '191.650',
        },
      },
      {
        team1: {
          matchup: 'Paradise Black Hawks',
          score: '320.875',
        },
        team2: {
          matchup: 'SurfDogs',
          score: '238.150',
        },
      },
      {
        team1: {
          matchup: 'Tiger Sharks',
          score: '295.475',
        },
        team2: {
          matchup: 'Doom',
          score: '325.900',
        },
      },
    ],
  },
  {
    title: 'Week 1 Head-To-Head Results',
    data: [
      {
        team1: {
          matchup: 'Tiger Sharks',
          score: '295.475',
        },
        team2: {
          matchup: 'Doom',
          score: '325.900',
        },
      },
      {
        team1: {
          matchup: 'Paradise Black Hawks',
          score: '320.875',
        },
        team2: {
          matchup: 'SurfDogs',
          score: '238.150',
        },
      },
      {
        team1: {
          matchup: 'Heat Wave',
          score: '425.825',
        },
        team2: {
          matchup: 'GhostRiders',
          score: '191.650',
        },
      },
      {
        team1: {
          matchup: 'Paradise Black Hawks',
          score: '320.875',
        },
        team2: {
          matchup: 'SurfDogs',
          score: '238.150',
        },
      },
      {
        team1: {
          matchup: 'Tiger Sharks',
          score: '295.475',
        },
        team2: {
          matchup: 'Doom',
          score: '325.900',
        },
      },
      {
        team1: {
          matchup: 'Paradise Black Hawks',
          score: '320.875',
        },
        team2: {
          matchup: 'SurfDogs',
          score: '238.150',
        },
      },
      {
        team1: {
          matchup: 'Heat Wave',
          score: '425.825',
        },
        team2: {
          matchup: 'GhostRiders',
          score: '191.650',
        },
      },
      {
        team1: {
          matchup: 'Paradise Black Hawks',
          score: '320.875',
        },
        team2: {
          matchup: 'SurfDogs',
          score: '238.150',
        },
      },
      {
        team1: {
          matchup: 'Tiger Sharks',
          score: '295.475',
        },
        team2: {
          matchup: 'Doom',
          score: '325.900',
        },
      },
      {
        team1: {
          matchup: 'Heat Wave',
          score: '425.825',
        },
        team2: {
          matchup: 'GhostRiders',
          score: '191.650',
        },
      },
      {
        team1: {
          matchup: 'Paradise Black Hawks',
          score: '320.875',
        },
        team2: {
          matchup: 'SurfDogs',
          score: '238.150',
        },
      },
      {
        team1: {
          matchup: 'Tiger Sharks',
          score: '295.475',
        },
        team2: {
          matchup: 'Doom',
          score: '325.900',
        },
      },
      {
        team1: {
          matchup: 'Paradise Black Hawks',
          score: '320.875',
        },
        team2: {
          matchup: 'SurfDogs',
          score: '238.150',
        },
      },
      {
        team1: {
          matchup: 'Heat Wave',
          score: '425.825',
        },
        team2: {
          matchup: 'GhostRiders',
          score: '191.650',
        },
      },
      {
        team1: {
          matchup: 'Paradise Black Hawks',
          score: '320.875',
        },
        team2: {
          matchup: 'SurfDogs',
          score: '238.150',
        },
      },
      {
        team1: {
          matchup: 'Tiger Sharks',
          score: '295.475',
        },
        team2: {
          matchup: 'Doom',
          score: '325.900',
        },
      },
    ],
  },
]

export const adpReportData = [
  {
    player: 'Taylor, Jonathan IND RB',
    rank: 1,
    key: 1,
    roster: 'CanWest Gladiators',
    avgPick: 1.12,
    minPack: 1,
    manPack: 2,
    selectedPercent: 51,
  },
  {
    player: 'McCaffrey, Christian SFO RB',
    rank: 2,
    key: 2,
    roster: 'Valkyries',
    avgPick: 2.81,
    minPack: 1,
    manPack: 6,
    selectedPercent: 51,
  },
  {
    player: 'Ekeler, Asutin LAC RB',
    rank: 3,
    key: 3,
    roster: 'Hydra',
    avgPick: 3.6,
    minPack: 2,
    manPack: 6,
    selectedPercent: 48,
  },
  {
    player: 'Henry, Derrick TEN RB',
    rank: 4,
    key: 4,
    roster: 'Kingsmen',
    avgPick: 4.06,
    minPack: 1,
    manPack: 8,
    selectedPercent: 51,
  },
  {
    player: 'Kupp, Cooper LAR WR',
    rank: 5,
    key: 5,
    roster: 'Hammerheads',
    avgPick: 4.89,
    minPack: 2,
    manPack: 11,
    selectedPercent: 29,
  },
  {
    player: 'Cook, Dalvin MIN RB',
    rank: 6,
    key: 6,
    roster: 'Worriors',
    avgPick: 5.5,
    minPack: 1,
    manPack: 13,
    selectedPercent: 64,
  },
  {
    player: 'Mixon, Joe CIN RB',
    rank: 7,
    key: 7,
    roster: 'Doom',
    avgPick: 7.4,
    minPack: 1,
    manPack: 14,
    selectedPercent: 64,
  },
  {
    player: 'Harris, Najee PIT RB',
    rank: 8,
    key: 8,
    roster: 'Circa Sports Trout',
    avgPick: 7.5,
    minPack: 2,
    manPack: 14,
    selectedPercent: 32,
  },
  {
    player: 'Jefferson, Justin MIN WR',
    rank: 9,
    key: 9,
    roster: 'CanWest Gladiators',
    avgPick: 7.5,
    minPack: 4,
    manPack: 10,
    selectedPercent: 19,
  },
  {
    player: 'Adams, Davante LVR WR',
    rank: 10,
    key: 10,
    roster: 'Warriors',
    avgPick: 9.88,
    minPack: 2,
    manPack: 18,
    selectedPercent: 54,
  },
  {
    player: 'Swift, D’Andre DET RB',
    rank: 11,
    key: 11,
    roster: 'Red Zone Dragons',
    avgPick: 10.0,
    minPack: 3,
    manPack: 20,
    selectedPercent: 54,
  },
  {
    player: 'Kamara, Alvin NOS RB',
    rank: 12,
    key: 12,
    roster: 'The Flying Foxes',
    avgPick: 10.5,
    minPack: 2,
    manPack: 20,
    selectedPercent: 51,
  },
  {
    player: 'Diggs, Stefon BUF WR',
    rank: 13,
    key: 13,
    roster: 'Gridiron Seals',
    avgPick: 11.24,
    minPack: 5,
    manPack: 19,
    selectedPercent: 54,
  },
  {
    player: 'Allen, Josh BUF QB',
    rank: 14,
    key: 14,
    roster: 'Gridiron Seals',
    avgPick: 11.27,
    minPack: 1,
    manPack: 32,
    selectedPercent: 48,
  },
  {
    player: 'Chase, Ja’Marr CIN WR',
    rank: 15,
    key: 15,
    roster: 'Gridiron Seals',
    avgPick: 12.2,
    minPack: 5,
    manPack: 19,
    selectedPercent: 16,
  },
  {
    player: 'Kelce, Travis KCC TE',
    rank: 16,
    key: 16,
    roster: 'Warriors',
    avgPick: 12.77,
    minPack: 1,
    manPack: 24,
    selectedPercent: 70,
  },
  {
    player: 'Chubb, Nick CLE RB',
    rank: 17,
    key: 17,
    roster: 'Legion',
    avgPick: 13.5,
    minPack: 7,
    manPack: 28,
    selectedPercent: 45,
  },
  {
    player: 'Fournette, Leonard TBB RB',
    rank: 18,
    key: 18,
    roster: 'Heat Wave',
    avgPick: 13.65,
    minPack: 4,
    manPack: 32,
    selectedPercent: 64,
  },
  {
    player: 'Barkley, Saquon NYG RB',
    rank: 19,
    key: 19,
    roster: 'Valkyries',
    avgPick: 14.33,
    minPack: 7,
    manPack: 28,
    selectedPercent: 58,
  },
  {
    player: 'Herbert, Justin LAC QB',
    rank: 20,
    key: 20,
    roster: 'Circa Sports Trout',
    avgPick: 14.7,
    minPack: 1,
    manPack: 32,
    selectedPercent: 32,
  },
  {
    player: 'Jones, Aaron GBP RB',
    rank: 21,
    key: 21,
    roster: 'Blockchain Bounty Hunters',
    avgPick: 15.0,
    minPack: 5,
    manPack: 28,
    selectedPercent: 51,
  },
  {
    player: 'Lamb, CeeDee DAL WR',
    rank: 22,
    key: 22,
    roster: 'Rowdys',
    avgPick: 16.0,
    minPack: 8,
    manPack: 26,
    selectedPercent: 41,
  },
  {
    player: 'Samiel, Deebo SFO WR',
    rank: 23,
    key: 23,
    roster: 'Legion',
    avgPick: 16.1,
    minPack: 5,
    manPack: 32,
    selectedPercent: 51,
  },
  {
    player: 'Conner, JAmes ARI RB',
    rank: 24,
    key: 24,
    roster: 'Outcasts',
    avgPick: 16.25,
    minPack: 2,
    manPack: 37,
    selectedPercent: 58,
  },
  {
    player: 'Andrews, Mark BAL TE',
    rank: 25,
    key: 25,
    roster: 'Rowdys',
    avgPick: 17.17,
    minPack: 2,
    manPack: 35,
    selectedPercent: 54,
  },
  {
    player: 'Hill, Tyreek MIA WR',
    rank: 26,
    key: 26,
    roster: 'Valkyries',
    avgPick: 17.18,
    minPack: 1,
    manPack: 34,
    selectedPercent: 35,
  },
  {
    player: 'Williams, Javonate DEN RB',
    rank: 27,
    key: 27,
    roster: 'Timberwolbes',
    avgPick: 17.64,
    minPack: 6,
    manPack: 30,
    selectedPercent: 77,
  },
  {
    player: 'Allen, Keenan LAC WR',
    rank: 28,
    key: 28,
    roster: 'Red Zone Dragons',
    avgPick: 20.17,
    minPack: 1,
    manPack: 38,
    selectedPercent: 58,
  },
  {
    player: 'Elliott, Ezekiel Dal RB',
    rank: 29,
    key: 29,
    roster: 'Hydra',
    avgPick: 21.06,
    minPack: 10,
    manPack: 45,
    selectedPercent: 32,
  },
  {
    player: 'Evans, Mike TBB WR',
    rank: 30,
    key: 30,
    roster: 'Tiger SHarks',
    avgPick: 21.32,
    minPack: 2,
    manPack: 37,
    selectedPercent: 83,
  },
  {
    player: 'Mahomes, Patrick KCC QB',
    rank: 31,
    key: 31,
    roster: 'The Flying FOxes',
    avgPick: 21.93,
    minPack: 6,
    manPack: 45,
    selectedPercent: 38,
  },
  {
    player: 'Akers, Cam LAR RB',
    rank: 32,
    key: 32,
    roster: 'Paradise Black Hawks',
    avgPick: 22.1,
    minPack: 12,
    manPack: 37,
    selectedPercent: 25,
  },
  {
    player: 'Montgomery, David Chi RB',
    rank: 33,
    key: 33,
    roster: 'Rage',
    avgPick: 22.15,
    minPack: 10,
    manPack: 39,
    selectedPercent: 77,
  },
  {
    player: 'Pittman, Michael IND WR',
    rank: 34,
    key: 34,
    roster: 'Paradise Black Hawks',
    avgPick: 22.75,
    minPack: 3,
    manPack: 51,
    selectedPercent: 58,
  },
  {
    player: 'Etienne, Travis Jac RB',
    rank: 35,
    key: 35,
    roster: '77 Angles',
    avgPick: 23.12,
    minPack: 5,
    manPack: 59,
    selectedPercent: 38,
  },
  {
    player: 'Hall, Breece NYJ RB (R)',
    rank: 36,
    key: 36,
    roster: 'TImberwolves',
    avgPick: 24.61,
    minPack: 2,
    manPack: 67,
    selectedPercent: 77,
  },
  {
    player: 'Brown, A.J. PHI WR',
    rank: 37,
    key: 37,
    roster: 'Heat Wave',
    avgPick: 24.92,
    minPack: 6,
    manPack: 52,
    selectedPercent: 58,
  },
  {
    player: 'Pitts, Kyle ATL TE',
    rank: 38,
    key: 38,
    roster: 'Valkyries',
    avgPick: 25.75,
    minPack: 12,
    manPack: 47,
    selectedPercent: 83,
  },
  {
    player: 'Jacobs, Josh LVR RB',
    rank: 39,
    key: 39,
    roster: 'Circa Sports Trout - IR',
    avgPick: 28.29,
    minPack: 16,
    manPack: 44,
    selectedPercent: 54,
  },
  {
    player: 'Jackson, Lamar Bal BQ',
    rank: 40,
    key: 40,
    roster: 'CanWest Gladiators',
    avgPick: 28.58,
    minPack: 4,
    manPack: 83,
    selectedPercent: 48,
  },
  {
    player: 'St. Brown, Amon-Ra Det WR',
    rank: 41,
    key: 41,
    roster: 'Circa SPorts Trout',
    avgPick: 30.23,
    minPack: 1,
    manPack: 52,
    selectedPercent: 32,
  },
  {
    player: 'Hurts, Jalen PHI QB',
    rank: 42,
    key: 42,
    roster: 'Legion',
    avgPick: 30.79,
    minPack: 10,
    manPack: 58,
    selectedPercent: 83,
  },
  {
    player: 'Higgins, Tee CIN WR',
    rank: 43,
    key: 43,
    roster: 'Legion',
    avgPick: 31.73,
    minPack: 2,
    manPack: 59,
    selectedPercent: 54,
  },
  {
    player: 'Williams, Mike LAC WR',
    rank: 44,
    key: 44,
    roster: 'Storm Breakers',
    avgPick: 32.63,
    minPack: 6,
    manPack: 78,
    selectedPercent: 35,
  },
  {
    player: 'Murray, Kyler ARI QB',
    rank: 45,
    key: 45,
    roster: 'DeFiance',
    avgPick: 32.67,
    minPack: 12,
    manPack: 70,
    selectedPercent: 77,
  },
  {
    player: 'Sutton, Courtland DEN WR',
    rank: 46,
    key: 46,
    roster: 'Empire',
    avgPick: 32.71,
    minPack: 16,
    manPack: 52,
    selectedPercent: 58,
  },
  {
    player: 'Moore, D.J. CAR WR',
    rank: 47,
    key: 47,
    roster: 'Blockchain Bounty Hunters',
    avgPick: 34.8,
    minPack: 4,
    manPack: 58,
    selectedPercent: 59,
  },
  {
    player: 'Burrow, Joe CIN QB',
    rank: 48,
    key: 48,
    roster: 'Rowdys',
    avgPick: 36.35,
    minPack: 1,
    manPack: 83,
    selectedPercent: 78,
  },
  {
    player: 'Thielen, Adam MIN WR',
    rank: 49,
    key: 49,
    roster: 'Legion',
    avgPick: 36.65,
    minPack: 10,
    manPack: 70,
    selectedPercent: 70,
  },
  {
    player: 'Dobbins, J.K. BAL RB',
    rank: 50,
    key: 50,
    roster: 'Outcasts',
    avgPick: 37.58,
    minPack: 2,
    manPack: 45,
    selectedPercent: 48,
  },
]

export const draftPicksData = [
  {
    key: 1,
    round: 1,
    currentPickOwner: 'Paradise Black Hawks',
    orignalPickOwner: 'Paradise Black Hawks',
  },
  {
    key: 2,
    round: 2,
    currentPickOwner: 'Blockchain Bounty Hunters',
    orignalPickOwner: 'Blockchain Bounty Hunters',
  },
  {
    key: 3,
    round: 3,
    currentPickOwner: 'Circa Sports Trout',
    orignalPickOwner: 'Circa Sports Trout',
  },
  {
    key: 4,
    round: 4,
    currentPickOwner: 'SurfDogs',
    orignalPickOwner: 'SurfDogs',
  },
  {
    key: 5,
    round: 5,
    currentPickOwner: '77 Angels',
    orignalPickOwner: '77 Angels',
  },
  {
    key: 6,
    round: 6,
    currentPickOwner: 'Timberwolves',
    orignalPickOwner: 'Timberwolves',
  },
  {
    key: 7,
    round: 7,
    currentPickOwner: 'Paradise Black Hawks',
    orignalPickOwner: 'Paradise Black Hawks',
  },
  {
    key: 8,
    round: 8,
    currentPickOwner: 'Blockchain Bounty Hunters',
    orignalPickOwner: 'Blockchain Bounty Hunters',
  },
  {
    key: 9,
    round: 9,
    currentPickOwner: 'Circa Sports Trout',
    orignalPickOwner: 'Circa Sports Trout',
  },
  {
    key: 10,
    round: 10,
    currentPickOwner: 'SurfDogs',
    orignalPickOwner: 'SurfDogs',
  },
  {
    key: 11,
    round: 11,
    currentPickOwner: '77 Angels',
    orignalPickOwner: '77 Angels',
  },
  {
    key: 12,
    round: 12,
    currentPickOwner: 'Timberwolves',
    orignalPickOwner: 'Timberwolves',
  },
  {
    key: 12,
    round: 12,
    currentPickOwner: 'Paradise Black Hawks',
    orignalPickOwner: 'Paradise Black Hawks',
  },
  {
    key: 14,
    round: 14,
    currentPickOwner: 'Blockchain Bounty Hunters',
    orignalPickOwner: 'Blockchain Bounty Hunters',
  },
  {
    key: 15,
    round: 15,
    currentPickOwner: 'Circa Sports Trout',
    orignalPickOwner: 'Circa Sports Trout',
  },
  {
    key: 16,
    round: 16,
    currentPickOwner: 'SurfDogs',
    orignalPickOwner: 'SurfDogs',
  },
  {
    key: 17,
    round: 17,
    currentPickOwner: '77 Angels',
    orignalPickOwner: '77 Angels',
  },
  {
    key: 18,
    round: 18,
    currentPickOwner: 'Timberwolves',
    orignalPickOwner: 'Timberwolves',
  },
  {
    key: 19,
    round: 19,
    currentPickOwner: 'Paradise Black Hawks',
    orignalPickOwner: 'Paradise Black Hawks',
  },
  {
    key: 20,
    round: 20,
    currentPickOwner: 'Blockchain Bounty Hunters',
    orignalPickOwner: 'Blockchain Bounty Hunters',
  },
  {
    key: 21,
    round: 21,
    currentPickOwner: 'Circa Sports Trout',
    orignalPickOwner: 'Circa Sports Trout',
  },
  {
    key: 22,
    round: 22,
    currentPickOwner: 'SurfDogs',
    orignalPickOwner: 'SurfDogs',
  },
  {
    key: 23,
    round: 23,
    currentPickOwner: '77 Angels',
    orignalPickOwner: '77 Angels',
  },
  {
    key: 24,
    round: 24,
    currentPickOwner: 'Timberwolves',
    orignalPickOwner: 'Timberwolves',
  },
  {
    key: 25,
    round: 25,
    currentPickOwner: 'Paradise Black Hawks',
    orignalPickOwner: 'Paradise Black Hawks',
  },
  {
    key: 26,
    round: 26,
    currentPickOwner: 'Blockchain Bounty Hunters',
    orignalPickOwner: 'Blockchain Bounty Hunters',
  },
  {
    key: 27,
    round: 27,
    currentPickOwner: 'Circa Sports Trout',
    orignalPickOwner: 'Circa Sports Trout',
  },
  {
    key: 28,
    round: 28,
    currentPickOwner: 'SurfDogs',
    orignalPickOwner: 'SurfDogs',
  },
  {
    key: 29,
    round: 29,
    currentPickOwner: '77 Angels',
    orignalPickOwner: '77 Angels',
  },
  {
    key: 30,
    round: 30,
    currentPickOwner: 'Timberwolves',
    orignalPickOwner: 'Timberwolves',
  },
  {
    key: 31,
    round: 31,
    currentPickOwner: 'Paradise Black Hawks',
    orignalPickOwner: 'Paradise Black Hawks',
  },
  {
    key: 32,
    round: 32,
    currentPickOwner: 'Blockchain Bounty Hunters',
    orignalPickOwner: 'Blockchain Bounty Hunters',
  },
  {
    key: 33,
    round: 33,
    currentPickOwner: 'Circa Sports Trout',
    orignalPickOwner: 'Circa Sports Trout',
  },
]

export const rosterWStatsData = [
  {
    key: 1,
    week: 'Fantasy Points',
    week1: 54.95,
    week2: 28.75,
    week3: 26.3,
    week4: 38.55,
    week5: 47.8,
    week6: 32.6,
    week7: 42.15,
    week8: 'B',
    week9: 50.1,
    week10: 49.45,
    week11: 41.35,
    week12: 29.6,
    week13: 27.55,
    week14: 35.35,
    week15: 48.05,
    week16: 33.5,
    week17: 41.2,
    week18: 23.05,
    total: 650.3,
    avg: 38.2529,
  },
  {
    key: 2,
    week: 'Pass Completions',
    week1: 54.95,
    week2: 28.75,
    week3: 26.3,
    week4: 38.55,
    week5: 47.8,
    week6: 32.6,
    week7: 42.15,
    week8: 'B',
    week9: 50.1,
    week10: 49.45,
    week11: 41.35,
    week12: 29.6,
    week13: 27.55,
    week14: 35.35,
    week15: 48.05,
    week16: 33.5,
    week17: 41.2,
    week18: 23.05,
    total: 650.3,
    avg: 38.2529,
  },
  {
    key: 3,
    week: 'Pass Attempts',
    week1: 54.95,
    week2: 28.75,
    week3: 26.3,
    week4: 38.55,
    week5: 47.8,
    week6: 32.6,
    week7: 42.15,
    week8: 'B',
    week9: 50.1,
    week10: 49.45,
    week11: 41.35,
    week12: 29.6,
    week13: 27.55,
    week14: 35.35,
    week15: 48.05,
    week16: 33.5,
    week17: 41.2,
    week18: 23.05,
    total: 650.3,
    avg: 38.2529,
  },
  {
    key: 4,
    week: 'Passing Yards',
    week1: 54.95,
    week2: 28.75,
    week3: 26.3,
    week4: 38.55,
    week5: 47.8,
    week6: 32.6,
    week7: 42.15,
    week8: 'B',
    week9: 50.1,
    week10: 49.45,
    week11: 41.35,
    week12: 29.6,
    week13: 27.55,
    week14: 35.35,
    week15: 48.05,
    week16: 33.5,
    week17: 41.2,
    week18: 23.05,
    total: 650.3,
    avg: 38.2529,
  },
  {
    key: 5,
    week: 'Number of Passing TDs',
    week1: 54.95,
    week2: 28.75,
    week3: 26.3,
    week4: 38.55,
    week5: 47.8,
    week6: 32.6,
    week7: 42.15,
    week8: 'B',
    week9: 50.1,
    week10: 49.45,
    week11: 41.35,
    week12: 29.6,
    week13: 27.55,
    week14: 35.35,
    week15: 48.05,
    week16: 33.5,
    week17: 41.2,
    week18: 23.05,
    total: 650.3,
    avg: 38.2529,
  },
  {
    key: 6,
    week: 'Pass Interceptions Thrown',
    week1: 54.95,
    week2: 28.75,
    week3: 26.3,
    week4: 38.55,
    week5: 47.8,
    week6: 32.6,
    week7: 42.15,
    week8: 'B',
    week9: 50.1,
    week10: 49.45,
    week11: 41.35,
    week12: 29.6,
    week13: 27.55,
    week14: 35.35,
    week15: 48.05,
    week16: 33.5,
    week17: 41.2,
    week18: 23.05,
    total: 650.3,
    avg: 38.2529,
  },
  {
    key: 7,
    week: 'Rush Attempts',
    week1: 54.95,
    week2: 28.75,
    week3: 26.3,
    week4: 38.55,
    week5: 47.8,
    week6: 32.6,
    week7: 42.15,
    week8: 'B',
    week9: 50.1,
    week10: 49.45,
    week11: 41.35,
    week12: 29.6,
    week13: 27.55,
    week14: 35.35,
    week15: 48.05,
    week16: 33.5,
    week17: 41.2,
    week18: 23.05,
    total: 650.3,
    avg: 38.2529,
  },
  {
    key: 8,
    week: 'Opponent',
    week1: '@ARI',
    week2: '@JDD',
    week3: '@HDU',
    week4: '@KHIG',
    week5: '@HUD',
    week6: '@UDD',
    week7: '@UYD',
    week8: 'B',
    week9: '@UGD',
    week10: '@IID',
    week11: '@KJD',
    week12: '@OUD',
    week13: '@YYD',
    week14: '@UYD',
    week15: '@TTS',
    week16: '@FGT',
    week17: '@JHG',
    week18: '@TRE',
    total: '',
    avg: '',
  },
]

export const rosterData = {
  title: 'PARADISE BLACK HAWKS',
  imageUrl: require('../assets/dragons_big.png'),
  player: [
    {
      name: 'Mahomes, Patrick KCC QB',
      pts: 650.3,
      bye: 8,
      salary: 35793382,
    },
    {
      name: 'Mahomes, Patrick KCC QB',
      pts: 650.3,
      bye: 8,
      salary: 35793382,
    },
    {
      name: 'Mahomes, Patrick KCC QB',
      pts: 650.3,
      bye: 8,
      salary: 35793382,
    },
    {
      name: 'Mahomes, Patrick KCC QB',
      pts: 650.3,
      bye: 8,
      salary: 35793382,
    },
    {
      name: 'Mahomes, Patrick KCC QB',
      pts: 650.3,
      bye: 8,
      salary: 35793382,
    },
    {
      name: 'Mahomes, Patrick KCC QB',
      pts: 650.3,
      bye: 8,
      salary: 35793382,
    },
    {
      name: 'Mahomes, Patrick KCC QB',
      pts: 650.3,
      bye: 8,
      salary: 35793382,
    },
    {
      name: 'Mahomes, Patrick KCC QB',
      pts: 650.3,
      bye: 8,
      salary: 35793382,
    },
    {
      name: 'Mahomes, Patrick KCC QB',
      pts: 650.3,
      bye: 8,
      salary: 35793382,
    },
    {
      name: 'Mahomes, Patrick KCC QB',
      pts: 650.3,
      bye: 8,
      salary: 35793382,
    },
    {
      name: 'Mahomes, Patrick KCC QB',
      pts: 650.3,
      bye: 8,
      salary: 35793382,
    },
    {
      name: 'Mahomes, Patrick KCC QB',
      pts: 650.3,
      bye: 8,
      salary: 35793382,
    },
    {
      name: 'Mahomes, Patrick KCC QB',
      pts: 650.3,
      bye: 8,
      salary: 35793382,
    },
    {
      name: 'Mahomes, Patrick KCC QB',
      pts: 650.3,
      bye: 8,
      salary: 35793382,
    },
    {
      name: 'Mahomes, Patrick KCC QB',
      pts: 650.3,
      bye: 8,
      salary: 35793382,
    },
    {
      name: 'Mahomes, Patrick KCC QB',
      pts: 650.3,
      bye: 8,
      salary: 35793382,
    },
    {
      name: 'Mahomes, Patrick KCC QB',
      pts: 650.3,
      bye: 8,
      salary: 35793382,
    },
    {
      name: 'Mahomes, Patrick KCC QB',
      pts: 650.3,
      bye: 8,
      salary: 35793382,
    },
    {
      name: 'Mahomes, Patrick KCC QB',
      pts: 650.3,
      bye: 8,
      salary: 35793382,
    },
    {
      name: 'Mahomes, Patrick KCC QB',
      pts: 650.3,
      bye: 8,
      salary: 35793382,
    },
    {
      name: 'Mahomes, Patrick KCC QB',
      pts: 650.3,
      bye: 8,
      salary: 35793382,
    },
    {
      name: 'Mahomes, Patrick KCC QB',
      pts: 650.3,
      bye: 8,
      salary: 35793382,
    },
    {
      name: 'Mahomes, Patrick KCC QB',
      pts: 650.3,
      bye: 8,
      salary: 35793382,
    },
    {
      name: 'Mahomes, Patrick KCC QB',
      pts: 650.3,
      bye: 8,
      salary: 35793382,
    },
    {
      name: 'Mahomes, Patrick KCC QB',
      pts: 650.3,
      bye: 8,
      salary: 35793382,
    },
    {
      name: 'Mahomes, Patrick KCC QB',
      pts: 650.3,
      bye: 8,
      salary: 35793382,
    },
    {
      name: 'Mahomes, Patrick KCC QB',
      pts: 650.3,
      bye: 8,
      salary: 35793382,
    },
  ],
  injuredReserve: [
    {
      name: 'Holyfield, Elijah CIN RB',
      pts: 'Warning! Possible IR Rule Violation Above.',
      bye: '10',
      salary: '$705,001',
    },
    {
      name: 'Gonzalez, Zane CAR PK',
      pts: 'Warning! Possible IR Rule Violation Above.',
      bye: '10',
      salary: '$705,001',
    },
    {
      name: "Hand, Da'Shawn TEN DE",
      pts: 'Warning! Possible IR Rule Violation Above.',
      bye: '10',
      salary: '$705,001',
    },
    {
      name: 'Anderson, Tycen CIN S (R)',
      pts: 'Warning! Possible IR Rule Violation Above.',
      bye: '10',
      salary: '$705,001',
    },
    {
      name: 'Hyde, Micah BUF S',
      pts: 'Warning! Possible IR Rule Violation Above.',
      bye: '10',
      salary: '$705,001',
    },
  ],
  totalPlayersOnIr: {
    totalPlayerIr: 5,
    title: 'taxi squad',
    totalPlayer: 6,
    data: [
      {
        name: 'Jones, Xavier FA RB',
        pts: '--',
        bye: '--',
        salary: '$35,793,382',
      },
      {
        name: 'Hurns, Allen FA WR',
        pts: 650.3,
        bye: 8,
        salary: '$35,793,382',
      },
      {
        name: 'Ward, Greg PHI WR',
        pts: 650.3,
        bye: 8,
        salary: '$35,793,382',
      },
      {
        name: 'Funchess, Devin FA TE',
        pts: 650.3,
        bye: 8,
        salary: '$35,793,382',
      },
      {
        name: 'Harris, Demetrius FA TE',
        pts: 650.3,
        bye: 8,
        salary: '$35,793,382',
      },
      {
        name: 'Tartt, Jaquiski FA S',
        pts: 650.3,
        bye: 8,
        salary: '$35,793,382',
      },
    ],
  },
}

// all reports
export const stats = {
  name: 'STATS',
  data: [
    {
      name: 'Top Perfromers/Player Stats',
    },
    {
      name: 'Project Stats',
    },
    {
      name: 'Starter Pts - Position',
    },
    {
      name: 'Starter Pts - Player',
    },
    {
      name: 'Points Allowed - By Position',
    },
  ],
}
export const standings = {
  title: 'STANDINGS',
  data: [
    {
      name: 'Standings',
    },
    {
      name: 'Power Rank',
    },
    {
      name: 'Tiebreakers',
    },
    {
      name: 'Victory Points Summary',
    },
  ],
}

export const players = {
  name: 'PLAYERS',
  data: [
    {
      name: 'FantasySharks.com Player Ranks',
    },
    {
      name: 'Player Salaries and Contracts',
    },
    {
      name: 'Salary Adjustments',
    },
    {
      name: 'Top Adds/Drops/Starters',
    },
    {
      name: 'Complete Free Agent Listing',
    },
    {
      name: 'Player Search',
    },

    {
      name: 'Player Additions and Positions Changes',
    },
  ],
}
export const playerNews = {
  name: 'PLAYER NEWS',
  data: [
    {
      name: 'Player News',
    },
  ],
}

export const draft = {
  name: 'DRAFT',
  data: [
    {
      name: 'ADP Report',
    },
    {
      name: 'Future Draft Picks',
    },
  ],
}

export const auction = {
  name: 'AUCTION',
  data: [
    {
      name: 'AAV Report',
    },
  ],
}

export const scoreAndResults = {
  name: 'SCORE AND RESULTS',
  data: [
    {
      name: 'Live Scoring',
    },
    {
      name: 'Fantasy Schedule',
    },
    {
      name: 'Weekly Results',
    },
    {
      name: 'Weekly Summary',
    },
    {
      name: 'Starting Lineups',
    },
    {
      name: 'Fantasy Previews',
    },
    {
      name: 'Fantasy Recaps',
    },
    {
      name: 'Bar Chart',
    },
    {
      name: 'Fantasy Box Score',
    },
    {
      name: 'Scoring History',
    },
  ],
}

export const leagueHistory = {
  name: 'LEAGUE HISTORY',
  data: [
    {
      name: 'League History',
    },
    {
      name: 'League Champions',
    },
    {
      name: 'League Awards',
    },
  ],
}

// Home
export const popularLeaguesData = [
  {
    title: 'American Football ',
    players: [4, 32],
    open: true,
    image: require('../assets/rectangle-5.png'),
    Logo: require('../assets/sam-football.png'),
  },
  {
    title: 'Hockey',
    players: [4, 32],
    open: true,
    image: require('../assets/hockey.png'),
    Logo: require('../assets/sam-hockey.png'),
  },
  {
    title: 'Baseball',
    players: [4, 32],
    open: true,
    image: require('../assets/baseball.png'),
    Logo: require('../assets/sam-baseball.png'),
  },
  {
    title: 'Basketball',
    players: [4, 32],
    open: true,
    image: require('../assets/basketball.png'),
    Logo: require('../assets/sam-basketball.png'),
  },
]
export const popularSportsData = [
  {
    title: 'American Football',
    icon: require('../assets/sam-football.png'),
    image: require('../assets/keith-johnston-vd-1-cz-99-sr-4-unsplash-1.png'),
  },
  {
    title: 'Hockey',
    different: true,
    icon: require('../assets/sam-hockey.png'),
    image: require('../assets/keith-johnston-hockey.png'),
  },
  {
    title: 'Baseball',
    icon: require('../assets/sam-baseball.png'),
    image: require('../assets/keith-johnston-baseball.png'),
  },
  {
    title: 'Basketball',
    icon: require('../assets/sam-basketball.png'),
    image: require('../assets/keith-johnston-basketball.png'),
  },
]
export const clientFeedbacksData = [
  {
    image: require('../assets/news-feed-1.jpg'),
    comment: `“Sam Sports is an absolute game-changer in the world of fantasy sports! From the moment I logged in, I was blown away by the sleek and smooth dashboard that greeted me. Navigating through the platform is an absolute breeze, thanks to its dope design. I've used several other fantasy sports platforms in the past, but Sam Sports has easily become my favorite due to its user-friendly interface.


      What sets Sam Sports apart is not just its ease of use, but the excitement it brings to fantasy sports enthusiasts like me. The range of sports and contests available is impressive, and the attention to detail in the unique scoring system, player stats and match updates is remarkable. Did I mention there is a GM rating feature and a Pro league that you could possibly get picked up for!  Regardless, whether you're a seasoned fantasy sports pro or just getting started, Sam Sports is the place to be. It's where strategy meets enjoyment, making it a must-try for all sports enthusiasts.”`,
    clientName: 'Max Voncito',
  },
  {
    image: require('../assets/news-feed-2.jpg'),
    comment: `“I’ve been playing fantasy football since 1994 and I’ve seen the game grow and grow but for some reason I was always wanting more from it. Along came SAM Sports and it has provided that extra challenge of salary cap issues, day-to-day roster movement and of course, my favorite part, the draft. The group of five auction is hands down the best way to get the competitive juices flowing during a draft. 

      The platform is impressive and for those of you who haven’t joined, why are you waiting for?!?!?”`,
    clientName: 'Jamie Thomas',
  },
  {
    image: require('../assets/news-feed-3.jpg'),
    comment: `“In my 25+ years of playing fantasy football, both as a team owner and as commissioner of many leagues, I’ve always searched for ways to simulate the NFL General Manager experience through manipulating scoring, roster settings, bringing in aspects of dynasty and college, contracts, and rules tailored to mirror the NFL. All platforms are customizable to some degree, but none allowed for the depth of the GM experience I was looking for. At SAM Sports, I’ve found my dream platform! From punters to offensive linemen, from scout rosters to practice squads, from college prospects to legends leagues, from player salaries to salary cap rules … it’s all there in a 32-team, high stakes league that challenges me at every level. I love how the scoring settings are tied to real life franchise tag numbers and how unique game-day settings make roster construction a critical part of your team’s success. I’ve never seen anything like it! SAM Sports has created what has to be the greatest fantasy football platform in terms simulating what it’s like to run a real NFL franchise. It will revolutionize the fantasy industry.”`,
    clientName: 'John Surdilla',
  },
  {
    image: require('../assets/user-rounded.webp'),
    comment: `“Being an owner of a  Pro Football and a Pro Hockey teams , it has been an outstanding journey for me and my GM, knowing that there is more to come. If you're looking for an innovative yet simulated version of pro sports then look no further, samsports is the one for you.”`,
    clientName: 'Thomas Christopher',
  },
]

export const proLeagueStandingsData = [
  {
    title: 'Red Zone Dragons',
    wlt: '11-6-0',
    avgPf: 308.6,
    avgPa: 266.0,
    divWlt: '5-1-0',
    divWlt2: '9-3-0',
  },
  {
    title: 'Paradise Black Hawks',
    wlt: '11-6-0',
    avgPf: 308.6,
    avgPa: 266.0,
    divWlt: '5-1-0',
    divWlt2: '9-3-0',
  },
  {
    title: 'Timberwolves',
    wlt: '11-6-0',
    avgPf: 308.6,
    avgPa: 266.0,
    divWlt: '5-1-0',
    divWlt2: '9-3-0',
  },
  {
    title: 'Surf Dogs',
    wlt: '11-6-0',
    avgPf: 308.6,
    avgPa: 266.0,
    divWlt: '5-1-0',
    divWlt2: '9-3-0',
  },
  {
    title: 'Gridiron Seals',
    wlt: '11-6-0',
    avgPf: 308.6,
    avgPa: 266.0,
    divWlt: '5-1-0',
    divWlt2: '9-3-0',
  },
  {
    title: 'Gridiron Seals',
    wlt: '11-6-0',
    avgPf: 308.6,
    avgPa: 266.0,
    divWlt: '5-1-0',
    divWlt2: '9-3-0',
  },
  {
    title: 'Tiger Sharks',
    wlt: '11-6-0',
    avgPf: 308.6,
    avgPa: 266.0,
    divWlt: '5-1-0',
    divWlt2: '9-3-0',
  },
  {
    title: 'Turf Monsters',
    wlt: '11-6-0',
    avgPf: 308.6,
    avgPa: 266.0,
    divWlt: '5-1-0',
    divWlt2: '9-3-0',
  },
  {
    title: 'Turf Monsters',
    wlt: '11-6-0',
    avgPf: 308.6,
    avgPa: 266.0,
    divWlt: '5-1-0',
    divWlt2: '9-3-0',
  },
  {
    title: 'Doom',
    wlt: '11-6-0',
    avgPf: 308.6,
    avgPa: 266.0,
    divWlt: '5-1-0',
    divWlt2: '9-3-0',
  },
]

export const powerRankingData = [
  {
    imageUrl: require('../assets/teams/circa_sports_trout.png'),
    title: 'Circa Sports Trout',
    text1: 54.06,
    text2: 0.937,
  },
  {
    imageUrl: require('../assets/teams/doom.png'),
    title: 'Doom',
    text1: 54.06,
    text2: 0.937,
  },
  {
    imageUrl: require('../assets/teams/circa_sports_trout.png'),
    title: 'Heat Wave',
    text1: 54.06,
    text2: 0.937,
  },
  {
    imageUrl: require('../assets/teams/kingsmen.png'),
    title: 'Kingsmen',
    text1: 54.06,
    text2: 0.937,
  },
  {
    imageUrl: require('../assets/teams/circa_sports_trout.png'),
    title: 'Hydra',
    text1: 54.06,
    text2: 0.937,
  },
  {
    imageUrl: require('../assets/teams/gridiron_seals.png'),
    title: 'Gridiron Seals',
    text1: 54.06,
    text2: 0.937,
  },
  {
    imageUrl: require('../assets/teams/legion.png'),
    title: 'Legion',
    text1: 54.06,
    text2: 0.937,
  },
]

export const playerRankingData = [
  {
    imageUrl: require('../assets/player-img-60x60.png'),
    title: 'Mahomes, Patrick KCC QB',
    amount: '650.300',
  },
  {
    imageUrl: require('../assets/player-img-2-60x60.png'),
    title: 'Allen, Josh BUF QB',
    amount: '607.750',
  },
  {
    imageUrl: require('../assets/player-img-12-PhotoRoom 1.png'),
    title: 'Burrow, Joe CIN QB',
    amount: '562.000',
  },
  {
    imageUrl: require('../assets/player-img-60x60.png'),
    title: 'Hurts, Jalen PHI QB',
    amount: '548.500',
  },
  {
    imageUrl: require('../assets/player-img-12-PhotoRoom 1.png'),
    title: 'Smith, Geno SEA QB',
    amount: '500.200',
  },
  {
    imageUrl: require('../assets/player-img-60x60.png'),
    title: 'Cousins, Kirk MIN QB',
    amount: '486.750',
  },
  {
    imageUrl: require('../assets/player-img-12-PhotoRoom 1.png'),
    title: 'Herbert, Justin LAC QB',
    amount: '486.750',
  },
]

export const transactionTrackerData = [
  {
    franchise: 'The Beast',
    type: 'Taxi Squad',
    date: new Date(),
    transaction: ['Bolton', 'Nick KCC LB', 'White', 'Kyzir PHI LB'],
  },
  {
    franchise: 'The Beast',
    type: 'Taxi Squad',
    date: new Date(),
    transaction: ['Bolton', 'Nick KCC LB', 'White', 'Kyzir PHI LB'],
  },
  {
    franchise: 'The Beast',
    type: 'Taxi Squad',
    date: new Date(),
    transaction: ['Bolton', 'Nick KCC LB', 'White', 'Kyzir PHI LB'],
  },
  {
    franchise: 'The Beast',
    type: 'Taxi Squad',
    date: new Date(),
    transaction: ['Bolton', 'Nick KCC LB', 'White', 'Kyzir PHI LB'],
  },
]

export const depthCardData = [
  {
    imageUrl: require('../assets/player-img-2.png'),
    Name: '',
    Position: 'te',
    classKey: 'offense_te',
    type: 'offense',
  },
  {
    imageUrl: require('../assets/player-img-1.png'),
    Name: '',
    Position: 'ol',
    classKey: 'offense_ol-1',
    type: 'offense',
  },
  {
    imageUrl: require('../assets/player-img-6.png'),
    Name: '',
    Position: 'ol',
    classKey: 'offense_ol-2',
    type: 'offense',
  },
  {
    imageUrl: require('../assets/player-img-5.png'),
    Name: '',
    Position: 'ol',
    classKey: 'offense_ol-3',
    type: 'offense',
  },
  {
    imageUrl: require('../assets/player-img-5.png'),
    Name: '',
    Position: 'ol',
    classKey: 'offense_ol-4',
    type: 'offense',
  },
  {
    imageUrl: require('../assets/player-img-1.png'),
    Name: '',
    Position: 'ol',
    classKey: 'offense_ol-5',
    type: 'offense',
  },
  {
    imageUrl: require('../assets/player-img-2.png'),
    Name: '',
    Position: 'wr',
    classKey: 'offense_wr-1',
    type: 'offense',
  },
  {
    imageUrl: require('../assets/player-img-4.png'),
    Name: '',
    Position: 'rb/wr/te',
    classKey: 'offense_rbwrte',
    type: 'offense',
  },
  {
    imageUrl: require('../assets/player-img-3.png'),
    Name: '',
    Position: 'qb',
    classKey: 'offense_qb-1',
    type: 'offense',
  },
  {
    imageUrl: require('../assets/player-img-5.png'),
    Name: '',
    Position: 'rb',
    classKey: 'offense_rb',
    type: 'offense',
  },
  {
    imageUrl: require('../assets/player-img-3.png'),
    Name: '',
    Position: 'wr',
    classKey: 'offense_wr-2',
    type: 'offense',
  },
  {
    imageUrl: require('../assets/player-img-2.png'),
    Name: '',
    Position: 'backup qb',
    classKey: 'offense_qb-2',
    type: 'offense',
  },
  {
    imageUrl: require('../assets/player-img-2.png'),
    Name: '',
    Position: 'cb/s',
    classKey: 'defense_cbs',
    type: 'defense',
  },
  {
    imageUrl: require('../assets/player-img-1.png'),
    Name: '',
    Position: 'lb',
    classKey: 'defense_lb-1',
    type: 'defense',
  },
  {
    imageUrl: require('../assets/player-img-6.png'),
    Name: '',
    Position: 'lb',
    classKey: 'defense_lb-2',
    type: 'defense',
  },
  {
    imageUrl: require('../assets/player-img-5.png'),
    Name: '',
    Position: 'lb/cb/s',
    classKey: 'defense_lbcbs',
    type: 'defense',
  },
  {
    imageUrl: require('../assets/player-img-5.png'),
    Name: '',
    Position: 'cb',
    classKey: 'defense_cb-1',
    type: 'defense',
  },
  {
    imageUrl: require('../assets/player-img-1.png'),
    Name: '',
    Position: 's',
    classKey: 'defense_s',
    type: 'defense',
  },
  {
    imageUrl: require('../assets/player-img-2.png'),
    Name: '',
    Position: 'de',
    classKey: 'defense_de',
    type: 'defense',
  },
  {
    imageUrl: require('../assets/player-img-4.png'),
    Name: '',
    Position: 'dt',
    classKey: 'defense_dt',
    type: 'defense',
  },
  {
    imageUrl: require('../assets/player-img-3.png'),
    Name: '',
    Position: 'dt/de',
    classKey: 'defense_dtde',
    type: 'defense',
  },
  {
    imageUrl: require('../assets/player-img-5.png'),
    Name: '',
    Position: 'dt/lb',
    classKey: 'defense_dtlb',
    type: 'defense',
  },
  {
    imageUrl: require('../assets/player-img-3.png'),
    Name: '',
    Position: 'cb',
    classKey: 'defense_cb-2',
    type: 'defense',
  },
  {
    imageUrl: require('../assets/player-img-2.png'),
    Name: '',
    Position: 'k',
    classKey: 'special_team_pk',
    type: 'special team',
  },
  {
    imageUrl: require('../assets/player-img-6.png'),
    Name: '',
    Position: 'p',
    classKey: 'special_team_pn',
    type: 'special team',
  },
]

export const playerInterfaceData = {
  name: "A'Shawn Robinson",
  status: 'Active Player',
  position: 'Gridiron Seals (UFAFL)',
  yearInLeague: '3 Years',
  age: '28 (Mar 21, 1995)',
  height: "6'4",
  playerCollege: 'College Name',
  pastYearStats: '2023 2022 2021',
  positionRank: 56,
  leagueRank: 22,
  playerNews:
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.',
  playerContractInfo:
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.',
}

export const practiceSquadData = [
  {
    title: 'Projected Spot',
    position: 'kcc',
    playerName: 'kcc',
    age: 'kcc',
    team: 'kcc',
    bye: 'kcc',
    playerCap: '7:05',
    yearLeftExperation: '',
    pointPerGame: '',
    playerRank: '',
  },
  {
    title: 'Projected Spot',
    position: 'kcc',
    playerName: 'kcc',
    age: 'kcc',
    team: 'kcc',
    bye: 'kcc',
    playerCap: '7:05',
    yearLeftExperation: '',
    pointPerGame: '',
    playerRank: '',
  },
  {
    title: 'Projected Spot',
    position: 'kcc',
    playerName: 'kcc',
    age: 'kcc',
    team: 'kcc',
    bye: 'kcc',
    playerCap: '7:05',
    yearLeftExperation: '',
    pointPerGame: '',
    playerRank: '',
  },
  {
    title: 'Un-projected Spot',
    position: 'kcc',
    playerName: 'kcc',
    age: 'kcc',
    team: 'kcc',
    bye: 'kcc',
    playerCap: '7:05',
    yearLeftExperation: '',
    pointPerGame: '',
    playerRank: '',
  },
]

export const PlayerStandingData = [
  {
    title: {
      left: '+ S HOWELL',
      right: 'QB-WAS(14) SUN 12PM VS ARI',
    },
    breakers: ['fantasy', 'rushing', 'receiving', 'passing'],
    points: '29',
    att: '4',
    yd: '8',
    td: '0',
    rec: '-',
    tar: '-',
    yd2: '-',
    td2: '-',
    cmp: '20',
    att2: '31',
    yd3: '222',
    td3: '1',
  },
  {
    title: {
      left: '+ S HOWELL',
      right: 'QB-WAS(14) SUN 12PM VS ARI',
    },
    breakers: ['fantasy', 'rushing', 'receiving', 'passing'],
    points: '29',
    att: '4',
    yd: '8',
    td: '0',
    rec: '-',
    tar: '-',
    yd2: '-',
    td2: '-',
    cmp: '20',
    att2: '31',
    yd3: '222',
    td3: '1',
  },
  {
    title: {
      left: '+ S HOWELL',
      right: 'QB-WAS(14) SUN 12PM VS ARI',
    },
    breakers: ['fantasy', 'rushing', 'receiving', 'passing'],
    points: '29',
    att: '4',
    yd: '8',
    td: '0',
    rec: '-',
    tar: '-',
    yd2: '-',
    td2: '-',
    cmp: '20',
    att2: '31',
    yd3: '222',
    td3: '1',
  },
  {
    title: {
      left: '+ S HOWELL',
      right: 'QB-WAS(14) SUN 12PM VS ARI',
    },
    breakers: ['fantasy', 'rushing', 'receiving', 'passing'],
    points: '29',
    att: '4',
    yd: '8',
    td: '0',
    rec: '-',
    tar: '-',
    yd2: '-',
    td2: '-',
    cmp: '20',
    att2: '31',
    yd3: '222',
    td3: '1',
  },
]
